<template>
  <!-- Onboarding Requiremnets Modal -->
  <div v-if="SE_DNSA != 1 && !isContinue && !forBankMerchants">
    <div class="modal-overlay" v-show="showOnboardingModal0">
      <Modal
        class="custom-modal custom-modal-width2"
        v-show="showOnboardingModal0"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <div class="modal1 mt-2"></div>
              <div
                class="modal1 mt-2 ml-2"
                style="background-color: #f1f3f9"
              ></div>
              <div
                class="modal1 mt-2 ml-2"
                style="background-color: #f1f3f9"
              ></div>
              <div
                class="modal1 mt-2 ml-2"
                style="background-color: #f1f3f9"
              ></div>
              <div
                class="modal1 mt-2 ml-2"
                style="background-color: #f1f3f9"
              ></div>
              <div
                class="modal1 mt-2 ml-2"
                style="background-color: #f1f3f9"
              ></div>
              <div
                class="modal1 mt-2 ml-2"
                style="background-color: #f1f3f9"
              ></div>
              <div
                class="modal1 mt-2 ml-2"
                style="background-color: #f1f3f9"
              ></div>
              <button
                type="button"
                class="close"
                @click="closeOnboardingModal0"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-header">
              <div class="modal-header-container">
                <div class="modal-header-text2">
                  Note <br />
                  <div class="modal-text3">
                    The following document and information will be required,
                  </div>
                  <div class="modal-text3">
                    Kindly ensure they are available before you proceed. You can
                    as
                  </div>
                  <div class="modal-text3">well save and continue later.</div>
                </div>
              </div>
            </div>

            <div class="modal-body modal-body-requirements modal-text">
              <span class="card4-header ml-0">
                <img
                  class="custom-icon"
                  src="@/components/img/Sales_Assests/ovalIcon.svg"
                  alt="Custom Icon"
                />
                <strong>Tax Identification Number</strong> </span
              ><br /><br />
              <span class="card4-header ml-0">
                <img
                  class="custom-icon"
                  src="@/components/img/Sales_Assests/ovalIcon.svg"
                  alt="Custom Icon"
                />
                <strong>Government Issued ID Type</strong> </span
              ><br /><br />
              <span class="card4-header ml-0">
                <img
                  class="custom-icon"
                  src="@/components/img/Sales_Assests/ovalIcon.svg"
                  alt="Custom Icon"
                />
                <strong
                  >Proof Of Residential Address (Utility Bill)</strong
                > </span
              ><br /><br />
              <span class="card4-header ml-0">
                <img
                  class="custom-icon"
                  src="@/components/img/Sales_Assests/ovalIcon.svg"
                  alt="Custom Icon"
                />
                <strong>Drivers License</strong> </span
              ><br /><br />
              <span class="card4-header ml-0">
                <img
                  class="custom-icon"
                  src="@/components/img/Sales_Assests/ovalIcon.svg"
                  alt="Custom Icon"
                />
                <strong>Business Registration Code</strong> </span
              ><br /><br />
              <span class="card4-header ml-0">
                <img
                  class="custom-icon"
                  src="@/components/img/Sales_Assests/ovalIcon.svg"
                  alt="Custom Icon"
                />
                <strong>C.A.C Document</strong> </span
              ><br /><br />
              <span class="card4-header ml-0">
                <img
                  class="custom-icon"
                  src="@/components/img/Sales_Assests/ovalIcon.svg"
                  alt="Custom Icon"
                />
                <strong>Memorandum and Articles Of Association</strong> </span
              ><br /><br />
              <span class="card4-header ml-0">
                <img
                  class="custom-icon"
                  src="@/components/img/Sales_Assests/ovalIcon.svg"
                  alt="Custom Icon"
                />
                <strong>Status report</strong> </span
              ><br /><br />
              <span class="card4-header ml-0">
                <img
                  class="custom-icon"
                  src="@/components/img/Sales_Assests/ovalIcon.svg"
                  alt="Custom Icon"
                />
                <strong
                  >Letter Of Introduction for Authorized signatories</strong
                > </span
              ><br /><br />
              <span class="card4-header ml-0">
                <img
                  class="custom-icon"
                  src="@/components/img/Sales_Assests/ovalIcon.svg"
                  alt="Custom Icon"
                />
                <strong>Company Profile</strong> </span
              ><br /><br />
              <span class="card4-header ml-0">
                <img
                  class="custom-icon"
                  src="@/components/img/Sales_Assests/ovalIcon.svg"
                  alt="Custom Icon"
                />
                <strong>National Identification Number (NIN)</strong> </span
              ><br /><br />
              <span class="card4-header ml-0">
                <img
                  class="custom-icon"
                  src="@/components/img/Sales_Assests/ovalIcon.svg"
                  alt="Custom Icon"
                />
                <strong>Bank Verification Number (BVN)</strong> </span
              ><br /><br />
              <span class="card4-header ml-0">
                <img
                  class="custom-icon"
                  src="@/components/img/Sales_Assests/ovalIcon.svg"
                  alt="Custom Icon"
                />
                <strong>Bank Details</strong> </span
              ><br /><br />

              <span class="card4-header ml-0">
                <img
                  class="custom-icon"
                  src="@/components/img/Sales_Assests/ovalIcon.svg"
                  alt="Custom Icon"
                />
                <strong
                  >Cashier Details (Full Name, Phone Number, Email)<span
                    style="color: #a57d2b; font-size: 12px"
                  >
                    - Optional</span
                  ></strong
                > </span
              ><br /><br />

              <div class="docReq">
                <span class="card4-header ml-0">
                  <img
                    class="custom-icon"
                    src="@/components/img/Sales_Assests/ovalIcon.svg"
                    alt="Custom Icon"
                  />
                  <strong
                    >Indemnity Form
                    <span style="color: #a57d2b; font-size: 12px">
                      - Optional</span
                    >
                  </strong>
                </span>
                <span
                  style="
                    font-size: 12px;
                    color: #6f48ff;
                    display: flex;
                    cursor: pointer;
                  "
                  @click="downloadFile('IndemnityFORM')"
                >
                  <strong class="ml-10" style="color: #6f48ff"
                    >Download Template</strong
                  >
                  <img
                    class="custom-icon ml-1"
                    src="@/components/img/Sales_Assests/download-icon.svg"
                    alt="Custom Icon"
                  /> </span
                ><br />
              </div>
              <br />

              <div class="docReq">
                <span class="card4-header ml-0">
                  <img
                    class="custom-icon"
                    src="@/components/img/Sales_Assests/ovalIcon.svg"
                    alt="Custom Icon"
                  />
                  <strong>Nature Of Business Form </strong>
                </span>
                <span
                  style="
                    font-size: 12px;
                    color: #6f48ff;
                    display: flex;
                    cursor: pointer;
                  "
                  @click="downloadFile('NatureOfBusiness')"
                >
                  <strong class="ml-3" style="color: #6f48ff"
                    >Download Template</strong
                  >
                  <img
                    class="custom-icon ml-1"
                    src="@/components/img/Sales_Assests/download-icon.svg"
                    alt="Custom Icon"
                  />
                </span>
              </div>
              <br />
              <div class="docReq">
                <span class="card4-header ml-0">
                  <img
                    class="custom-icon"
                    src="@/components/img/Sales_Assests/ovalIcon.svg"
                    alt="Custom Icon"
                  />
                  <strong>Board of Resolution Form</strong>
                </span>
                <span
                  style="
                    font-size: 12px;
                    color: #6f48ff;
                    display: flex;
                    cursor: pointer;
                  "
                  @click="downloadFile('BOR')"
                >
                  <strong class="ml-3" style="color: #6f48ff"
                    >Download Template</strong
                  >
                  <img
                    class="custom-icon ml-1"
                    src="@/components/img/Sales_Assests/download-icon.svg"
                    alt="Custom Icon"
                  />
                </span>
              </div>
              <br />
              <div class="docReq">
                <span class="card4-header ml-0">
                  <img
                    class="custom-icon"
                    src="@/components/img/Sales_Assests/ovalIcon.svg"
                    alt="Custom Icon"
                  />
                  <strong>Non-Disclosure Agreement Form</strong>
                </span>
                <span
                  style="
                    font-size: 12px;
                    color: #6f48ff;
                    display: flex;
                    cursor: pointer;
                  "
                  @click="downloadFile('NDA')"
                >
                  <strong class="ml-3" style="color: #6f48ff"
                    >Download Template</strong
                  >
                  <img
                    class="custom-icon ml-1"
                    src="@/components/img/Sales_Assests/download-icon.svg"
                    alt="Custom Icon"
                  />
                </span>
              </div>
            </div>

            <div class="modal-footer">
              <div
                class="custom-control custom-checkbox small"
                style="margin-right: 130px; margin-left: 0px"
              >
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="customCheck"
                  v-model="DoNotShowAgain"
                />
                <label
                  class="custom-control-label ml-2"
                  style="
                    margin-bottom: 0;
                    font-size: 14px;
                    font-weight: bold;
                    color: #000;
                  "
                  for="customCheck"
                  >Do not show this again</label
                >
              </div>
              <div class="proceed-button" @click="openOnboardingModal1">
                Proceed
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  </div>
  <!-- Onboarding Modal 1 -->
  <div v-show="showOnboardingModal1">
    <div v-if="Flow1 == 1 || (SE_DNSA == 1 && onboardButtonClicked)">
      <div class="modal-overlay">
        <Modal
          class="custom-modal custom-modal-width2"
          v-show="showOnboardingModal1"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <div v-if="Flow1 == 1" class="modal1 mt-2"></div>
                <div class="modal1 mt-2 ml-2"></div>
                <div
                  class="modal1 mt-2 ml-2"
                  style="background-color: #f1f3f9"
                ></div>
                <div
                  class="modal1 mt-2 ml-2"
                  style="background-color: #f1f3f9"
                ></div>
                <div
                  class="modal1 mt-2 ml-2"
                  style="background-color: #f1f3f9"
                ></div>
                <div
                  class="modal1 mt-2 ml-2"
                  style="background-color: #f1f3f9"
                ></div>
                <div
                  class="modal1 mt-2 ml-2"
                  style="background-color: #f1f3f9"
                ></div>
                <div
                  class="modal1 mt-2 ml-2"
                  style="background-color: #f1f3f9"
                ></div>
                <button type="button" class="close" @click="CloseModal(1)">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-header">
                <div class="modal-header-container">
                  <div class="modal-header-text2">
                    Business Information <br />
                    <div class="modal-text3">
                      Please provide all information requested below in order to
                    </div>
                    <div class="modal-text3">
                      create a business account for your client.
                    </div>
                  </div>
                </div>
              </div>

              <form @submit.prevent="openOnboardingModal2">
                <div class="modal-body modal-body9 modal-text">
                  <!-- Type Dropdown -->
                  <div class="form-group">
                    <label for="businessType">Type:</label>
                    <div class="dropdown-container">
                      <select
                        id="type"
                        class="form-control"
                        v-model="businessType"
                        ref="dropdown2"
                        style="
                          font-size: 12px;
                          background-color: transparent;
                          cursor: pointer;
                          z-index: 2;
                        "
                        required
                      >
                        <option value="" disabled selected>
                          Select type of business
                        </option>
                        <option
                          v-for="type in businessTypes"
                          :key="type.id"
                          :value="type.business_type"
                        >
                          {{ type.business_type }}
                        </option>
                      </select>
                      <img
                        class="dropdown-icon"
                        src="@/components/img/Sales_Assests/dropdown.svg"
                        alt="Dropdown Icon"
                      />
                    </div>
                  </div>

                  <!-- Business Name -->
                  <div class="form-group">
                    <label for="businessName">Business Name:</label>
                    <input
                      type="text"
                      id="businessName"
                      maxlength="20"
                      class="form-control"
                      required
                      v-model="businessName"
                      placeholder="Enter Business Name"
                      style="font-size: 12px; background-color: #f8f9fc"
                    />
                  </div>

                  <!-- Email Address -->
                  <div class="form-group">
                    <label for="email">Email Address:</label>
                    <input
                      type="email"
                      id="email"
                      class="form-control"
                      required
                      v-model="email"
                      placeholder="Enter Email Address"
                      style="font-size: 12px; background-color: #f8f9fc"
                    />
                  </div>

                  <!-- Tax Identification Number -->
                  <div class="form-group">
                    <label for="taxNumber">Tax Identification Number:</label>
                    <input
                      type="text"
                      id="taxNumber"
                      class="form-control"
                      required
                      maxlength="13"
                      @input="validateTaxNumber"
                      v-model="taxNumber"
                      placeholder="Eg. 12345678-9101"
                      style="font-size: 12px; background-color: #f8f9fc"
                    />
                  </div>
                  <div
                    v-if="errorTINInput"
                    class="alert alert-danger"
                    role="alert"
                  >
                    {{ errorTINInput }}
                  </div>

                  <!-- Phone Number -->
                  <div class="form-group">
                    <label for="phoneNumber">Phone Number:</label>
                    <input
                      type="tel"
                      id="phoneNumber"
                      class="form-control"
                      @input="onPhoneInput"
                      required
                      maxlength="11"
                      v-model="phoneNumber"
                      placeholder="Enter Phone Number"
                      style="font-size: 12px; background-color: #f8f9fc"
                    />
                  </div>
                </div>

                <div class="modal-footer">
                  <div v-if="Flow1 != 1">
                    <div class="Save-button1" @click="saveAndContinue(1)">
                      Save & Continue Later
                    </div>
                  </div>
                  <div v-else-if="Flow1 == 1 && !forBankMerchants">
                    <div class="Save-button2" @click="saveAndContinue(1)">
                      Save & Continue Later
                    </div>
                  </div>
                  <div v-if="Flow1 == 1 && !forBankMerchants">
                    <div class="previous-button" @click="previousModal0">
                      Previous
                    </div>
                  </div>
                  <button class="onboardNext-button" type="submit">Next</button>
                </div>
              </form>
            </div>
          </div>
        </Modal>
      </div>
    </div>
  </div>
  <!-- Onboarding Modal2 -->
  <div class="modal-overlay" v-show="showOnboardingModal2">
    <Modal
      class="custom-modal custom-modal-width2"
      v-show="showOnboardingModal2"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div v-if="SE_DNSA != 1" class="modal1 mt-2"></div>
            <div class="modal1 mt-2 ml-2"></div>
            <div class="modal1 mt-2 ml-2"></div>
            <div
              class="modal1 mt-2 ml-2"
              style="background-color: #f1f3f9"
            ></div>
            <div
              class="modal1 mt-2 ml-2"
              style="background-color: #f1f3f9"
            ></div>
            <div
              class="modal1 mt-2 ml-2"
              style="background-color: #f1f3f9"
            ></div>
            <div
              class="modal1 mt-2 ml-2"
              style="background-color: #f1f3f9"
            ></div>
            <div
              class="modal1 mt-2 ml-2"
              style="background-color: #f1f3f9"
            ></div>
            <button type="button" class="close" @click="CloseModal(2)">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-header">
            <div class="modal-header-container">
              <div class="modal-header-text2">
                Business Documents <br />
                <div class="modal-text3">
                  Please provide all information requested below in order to
                </div>
                <div class="modal-text3">
                  create a business account for your client.
                </div>
              </div>
            </div>
          </div>

          <form @submit.prevent="openOnboardingModal3">
            <div class="modal-body modal-body9 modal-text">
              <div class="form-group">
                <label for="RegCode">Business Registration Code</label>
                <input
                  type="text"
                  id="RegCode"
                  class="form-control"
                  required
                  v-model="RegCode"
                  maxlength="8"
                  @input="onAlphanumericInput"
                  placeholder="Enter RC ( i.e RC 123456)"
                  style="font-size: 12px; background-color: #f8f9fc"
                />
                <div
                  v-if="errorRCInput"
                  class="alert alert-danger mt-1"
                  role="alert"
                >
                  {{ errorRCInput }}
                </div>
              </div>
              <!-- Type Dropdown -->
              <div class="form-group">
                <label for="GovID">Government Issued ID Type</label>
                <div class="dropdown-container">
                  <select
                    id="GovID"
                    class="form-control"
                    v-model="GovID"
                    @change="UpdateGovIDNumber"
                    ref="dropdown2"
                    @click="toggleDropdown"
                    style="font-size: 12px; background-color: #f8f9fc"
                    required
                  >
                    <option value="" disabled selected>
                      Select type of government-issued ID
                    </option>
                    <option value="International Passport">
                      International Passport
                    </option>
                    <option value="Driver`s licence">Driver's licence</option>
                    <option value="NIN Slip">NIN Slip</option>
                    <option value="Voter`s Card">Voter's Card</option>
                  </select>
                  <!-- <div class="dropdown-icon-container" >
                <img src="@/components/img/Sales_Assests/dropdown.svg" alt="Dropdown Icon" @click="toggleDropdown">
              </div> -->
                </div>
              </div>

              <!-- ID Type Number -->
              <div class="form-group">
                <div v-if="GovID == 'Default'"></div>

                <div v-else-if="GovID == 'International Passport'">
                  <input
                    type="text"
                    id="IDType"
                    class="form-control"
                    v-model="IDType"
                    placeholder="Enter your Passport number"
                    required
                    maxlength="9"
                    style="font-size: 12px; background-color: #f8f9fc"
                  />
                </div>

                <div v-else-if="GovID == 'Driver`s licence'">
                  <input
                    type="text"
                    id="IDType"
                    class="form-control"
                    v-model="IDType"
                    placeholder="Enter your Driver's License number"
                    required
                    maxlength="12"
                    style="font-size: 12px; background-color: #f8f9fc"
                  />
                </div>

                <div v-else-if="GovID == 'NIN Slip'">
                  <input
                    type="text"
                    id="IDType"
                    class="form-control"
                    v-model="IDType"
                    @input="onInput"
                    placeholder="Enter your NIN"
                    maxlength="11"
                    required
                    style="font-size: 12px; background-color: #f8f9fc"
                  />
                  <div
                    v-if="errorNINInput"
                    class="alert alert-danger mt-1"
                    role="alert"
                  >
                    {{ errorNINInput }}
                  </div>
                </div>

                <div v-else-if="GovID == 'Voter`s Card'">
                  <input
                    type="text"
                    id="IDType"
                    class="form-control"
                    v-model="IDType"
                    placeholder="Enter your Voter's Card Number"
                    required
                    maxlength="19"
                    style="font-size: 12px; background-color: #f8f9fc"
                  />
                </div>
              </div>

              <div
                class="file-upload-section"
                style="font-size: 12px; background-color: #f8f9fc"
              >
                <label for="govtIdUpload" class="upload-label">
                  <div class="upload-icon">
                    <img
                      src="@/components/img/Sales_Assests/uploadicon.svg"
                      alt="Upload Icon"
                    />
                  </div>
                  <div class="upload-text">
                    <div v-if="uploadedFile">
                      {{ uploadedFile.file.name }}
                      <span
                        class="ml-3"
                        aria-hidden="true"
                        @click="removeFile"
                        style="color: #da3734; font-size: 14px"
                        >&times;</span
                      >
                    </div>
                    <div v-else>
                      <div>Upload your Govt. issued ID</div>
                      <div class="small-text">
                        Supports JPG, PNG, PDF files only. Max size - 1.75MB
                      </div>
                    </div>
                  </div>
                </label>

                <div
                  v-if="fileUploadErrors.govtId"
                  style="color: #da3734; font-size: 12px; margin-top: 4px"
                >
                  {{ fileUploadErrors.govtId }}
                </div>

                <input
                  type="file"
                  id="govtIdUpload"
                  required
                  accept=".pdf,.jpeg,.jpg,.png"
                  multiple
                  class="file-input"
                  @change="handleFileChange($event, 'govtId')"
                  v-if="!uploadedFile"
                />
              </div>

              <!-- TIN Slip -->
              <div style="margin-top: 20px; margin-bottom: 20px">
                <div style="font-weight: bold">TIN Slip</div>
                <div
                  class="file-upload-section"
                  style="font-size: 12px; background-color: #f8f9fc"
                >
                  <label for="TinSlip" class="upload-label">
                    <div class="upload-icon">
                      <!-- Upload Icon (You can replace this with your SVG or icon) -->
                      <img
                        src="@/components/img/Sales_Assests/uploadicon.svg"
                        alt="Upload Icon"
                      />
                    </div>
                    <div class="upload-text">
                      <div v-if="uploadedTinSlip">
                        {{ uploadedTinSlip.file.name }}
                        <span
                          class="ml-3"
                          aria-hidden="true"
                          @click="removeFileTinSlip"
                          style="color: #da3734; font-size: 14px"
                          >&times;</span
                        >
                      </div>
                      <div v-else>
                        <div>Upload your TIN slip</div>
                        <div class="small-text">
                          Supports JPG, PNG, PDF files only. Max size - 1.75MB
                        </div>
                      </div>
                    </div>
                  </label>

                  <div
                    v-if="fileUploadErrors.tinSlip"
                    style="color: #da3734; font-size: 12px; margin-top: 4px"
                  >
                    {{ fileUploadErrors.tinSlip }}
                  </div>

                  <input
                    type="file"
                    id="TinSlip"
                    required
                    accept=".pdf,.jpeg,.jpg,.png"
                    multiple
                    ref="tinSlip"
                    class="file-input"
                    @change="handleFileChange($event, 'tinSlip')"
                    v-if="!uploadedTinSlip"
                  />
                </div>
              </div>

              <!-- Utility Bill         -->
              <div style="margin-bottom: 20px">
                <div style="font-weight: bold">Utility Bill</div>
                <div
                  class="file-upload-section"
                  style="font-size: 12px; background-color: #f8f9fc"
                >
                  <label for="utilitybill" class="upload-label">
                    <div class="upload-icon">
                      <!-- Upload Icon (You can replace this with your SVG or icon) -->
                      <img
                        src="@/components/img/Sales_Assests/uploadicon.svg"
                        alt="Upload Icon"
                      />
                    </div>
                    <div class="upload-text">
                      <div v-if="uploadedUtilityBill">
                        {{ uploadedUtilityBill.file.name }}
                        <span
                          class="ml-3"
                          aria-hidden="true"
                          @click="removeFileUtility"
                          style="color: #da3734; font-size: 14px"
                          >&times;</span
                        >
                      </div>
                      <div v-else>
                        <div>Upload a recent utility bill</div>
                        <div class="small-text">
                          Supports JPG, PNG, PDF files only. Max size - 1.75MB
                        </div>
                      </div>
                    </div>
                  </label>

                  <div
                    v-if="fileUploadErrors.utilityBill"
                    style="color: #da3734; font-size: 12px; margin-top: 4px"
                  >
                    {{ fileUploadErrors.utilityBill }}
                  </div>

                  <input
                    type="file"
                    id="utilitybill"
                    required
                    accept=".pdf,.jpeg,.jpg,.png"
                    multiple
                    ref="utilitybill"
                    class="file-input"
                    @change="handleFileChange($event, 'utilityBill')"
                    v-if="!uploadedUtilityBill"
                  />
                </div>
              </div>

              <!-- CAC Document -->
              <div style="margin-bottom: 20px">
                <div style="font-weight: bold">C.A.C Document</div>
                <div
                  class="file-upload-section"
                  style="font-size: 12px; background-color: #f8f9fc"
                >
                  <label for="CACDocument" class="upload-label">
                    <div class="upload-icon">
                      <!-- Upload Icon (You can replace this with your SVG or icon) -->
                      <img
                        src="@/components/img/Sales_Assests/uploadicon.svg"
                        alt="Upload Icon"
                      />
                    </div>
                    <div class="upload-text">
                      <div v-if="uploadedCAC">
                        {{ uploadedCAC.file.name }}
                        <span
                          class="ml-3"
                          aria-hidden="true"
                          @click="removeFileCAC"
                          style="color: #da3734; font-size: 14px"
                          >&times;</span
                        >
                      </div>
                      <div v-else>
                        <div>Upload your C.A.C Document</div>
                        <div class="small-text">
                          Supports JPG, PNG, PDF files only. Max size - 1.75MB
                        </div>
                      </div>
                    </div>
                  </label>

                  <div
                    v-if="fileUploadErrors.CACDocument"
                    style="color: #da3734; font-size: 12px; margin-top: 4px"
                  >
                    {{ fileUploadErrors.CACDocument }}
                  </div>

                  <input
                    type="file"
                    id="CACDocument"
                    required
                    accept=".pdf,.jpeg,.jpg,.png"
                    multiple
                    ref="CACDocument"
                    class="file-input"
                    @change="handleFileChange($event, 'CACDocument')"
                    v-if="!uploadedCAC"
                  />
                </div>
              </div>

              <!-- MEMART Report -->
              <div style="margin-bottom: 20px">
                <div style="font-weight: bold">
                  Memorandum and Articles Of Association
                </div>
                <div
                  class="file-upload-section"
                  style="font-size: 12px; background-color: #f8f9fc"
                >
                  <label for="MEMART" class="upload-label">
                    <div class="upload-icon">
                      <!-- Upload Icon (You can replace this with your SVG or icon) -->
                      <img
                        src="@/components/img/Sales_Assests/uploadicon.svg"
                        alt="Upload Icon"
                      />
                    </div>
                    <div class="upload-text">
                      <div v-if="uploadedMEMART">
                        {{ uploadedMEMART.file.name }}
                        <span
                          class="ml-3"
                          aria-hidden="true"
                          @click="removeFileMEMART"
                          style="color: #da3734; font-size: 14px"
                          >&times;</span
                        >
                      </div>
                      <div v-else>
                        <div>Upload MEMART</div>
                        <div class="small-text">
                          Supports JPG, PNG, PDF files only. Max size - 1.75MB
                        </div>
                      </div>
                    </div>
                  </label>

                  <div
                    v-if="fileUploadErrors.MEMART"
                    style="color: #da3734; font-size: 12px; margin-top: 4px"
                  >
                    {{ fileUploadErrors.MEMART }}
                  </div>

                  <input
                    type="file"
                    id="MEMART"
                    required
                    accept=".pdf,.jpeg,.jpg,.png"
                    multiple
                    ref="MEMART"
                    class="file-input"
                    @change="handleFileChange($event, 'MEMART')"
                    v-if="!uploadedMEMART"
                  />
                </div>
              </div>

              <!-- Status Report -->
              <div style="margin-bottom: 20px">
                <div style="font-weight: bold">Status Report</div>
                <div
                  class="file-upload-section"
                  style="font-size: 12px; background-color: #f8f9fc"
                >
                  <label for="StatusReport" class="upload-label">
                    <div class="upload-icon">
                      <!-- Upload Icon (You can replace this with your SVG or icon) -->
                      <img
                        src="@/components/img/Sales_Assests/uploadicon.svg"
                        alt="Upload Icon"
                      />
                    </div>
                    <div class="upload-text">
                      <div v-if="uploadedStatusReport">
                        {{ uploadedStatusReport.file.name }}
                        <span
                          class="ml-3"
                          aria-hidden="true"
                          @click="removeFileStatusReport"
                          style="color: #da3734; font-size: 14px"
                          >&times;</span
                        >
                      </div>
                      <div v-else>
                        <div>Upload Status Report</div>
                        <div class="small-text">
                          Supports JPG, PNG, PDF files only. Max size - 1.75MB
                        </div>
                      </div>
                    </div>
                  </label>

                  <div
                    v-if="fileUploadErrors.StatusReport"
                    style="color: #da3734; font-size: 12px; margin-top: 4px"
                  >
                    {{ fileUploadErrors.StatusReport }}
                  </div>

                  <input
                    type="file"
                    id="StatusReport"
                    required
                    accept=".pdf,.jpeg,.jpg,.png"
                    multiple
                    ref="StatusReport"
                    class="file-input"
                    @change="handleFileChange($event, 'StatusReport')"
                    v-if="!uploadedStatusReport"
                  />
                </div>
              </div>

              <!-- Letter of Intro -->
              <div style="margin-bottom: 20px">
                <div style="font-weight: bold">
                  Letter Of Introduction for Authorized signatories
                </div>
                <div
                  class="file-upload-section"
                  style="font-size: 12px; background-color: #f8f9fc"
                >
                  <label for="LetterOfIntro" class="upload-label">
                    <div class="upload-icon">
                      <!-- Upload Icon (You can replace this with your SVG or icon) -->
                      <img
                        src="@/components/img/Sales_Assests/uploadicon.svg"
                        alt="Upload Icon"
                      />
                    </div>
                    <div class="upload-text">
                      <div v-if="uploadedLetterOfIntro">
                        {{ uploadedLetterOfIntro.file.name }}
                        <span
                          class="ml-3"
                          aria-hidden="true"
                          @click="removeFileLetterOfIntro"
                          style="color: #da3734; font-size: 14px"
                          >&times;</span
                        >
                      </div>
                      <div v-else>
                        <div>
                          Upload Letter Of Introduction for Authorized
                          signatories
                        </div>
                        <div class="small-text">
                          Supports JPG, PNG, PDF files only. Max size - 1.75MB
                        </div>
                      </div>
                    </div>
                  </label>

                  <div
                    v-if="fileUploadErrors.LetterOfIntro"
                    style="color: #da3734; font-size: 12px; margin-top: 4px"
                  >
                    {{ fileUploadErrors.LetterOfIntro }}
                  </div>

                  <input
                    type="file"
                    id="LetterOfIntro"
                    required
                    accept=".pdf,.jpeg,.jpg,.png"
                    multiple
                    ref="LetterOfIntro"
                    class="file-input"
                    @change="handleFileChange($event, 'LetterOfIntro')"
                    v-if="!uploadedLetterOfIntro"
                  />
                </div>
              </div>

              <!-- Company Profile -->
              <div style="margin-bottom: 20px">
                <div style="font-weight: bold">Company Profile</div>
                <div
                  class="file-upload-section"
                  style="font-size: 12px; background-color: #f8f9fc"
                >
                  <label for="CompanyProfile" class="upload-label">
                    <div class="upload-icon">
                      <!-- Upload Icon (You can replace this with your SVG or icon) -->
                      <img
                        src="@/components/img/Sales_Assests/uploadicon.svg"
                        alt="Upload Icon"
                      />
                    </div>
                    <div class="upload-text">
                      <div v-if="uploadedCompanyProfile">
                        {{ uploadedCompanyProfile.file.name }}
                        <span
                          class="ml-3"
                          aria-hidden="true"
                          @click="removeFileCompanyProfile"
                          style="color: #da3734; font-size: 14px"
                          >&times;</span
                        >
                      </div>
                      <div v-else>
                        <div>Company Profile</div>
                        <div class="small-text">
                          Supports JPG, PNG, PDF files only. Max size - 1.75MB
                        </div>
                      </div>
                    </div>
                  </label>

                  <div
                    v-if="fileUploadErrors.CompanyProfile"
                    style="color: #da3734; font-size: 12px; margin-top: 4px"
                  >
                    {{ fileUploadErrors.CompanyProfile }}
                  </div>

                  <input
                    type="file"
                    id="CompanyProfile"
                    required
                    accept=".pdf,.jpeg,.jpg,.png"
                    multiple
                    ref="CompanyProfile"
                    class="file-input"
                    @change="handleFileChange($event, 'CompanyProfile')"
                    v-if="!uploadedCompanyProfile"
                  />
                </div>
              </div>

              <!-- Nature of Business -->
              <div style="margin-bottom: 20px">
                <div style="font-weight: bold">Nature Of Business Form</div>
                <div
                  class="file-upload-section"
                  style="font-size: 12px; background-color: #f8f9fc"
                >
                  <label for="NatureOFBusiness" class="upload-label">
                    <div class="upload-icon">
                      <!-- Upload Icon (You can replace this with your SVG or icon) -->
                      <img
                        src="@/components/img/Sales_Assests/uploadicon.svg"
                        alt="Upload Icon"
                      />
                    </div>
                    <div class="upload-text">
                      <div v-if="uploadedNatureOFBusiness">
                        {{ uploadedNatureOFBusiness.file.name }}
                        <span
                          class="ml-3"
                          aria-hidden="true"
                          @click="removeFileNatureOFBusiness"
                          style="color: #da3734; font-size: 14px"
                          >&times;</span
                        >
                      </div>
                      <div v-else>
                        <div>Upload Nature Of Business Form</div>
                        <div class="small-text">
                          Supports JPG, PNG, PDF files only. Max size - 1.75MB
                        </div>
                        <div
                          class="small-text"
                          style="color: #db8c09; font-weight: bold"
                        >
                          Make sure the uploaded document is the edited version
                          of the downloaded template.
                        </div>
                      </div>
                    </div>
                  </label>

                  <div
                    v-if="fileUploadErrors.NatureOFBusiness"
                    style="color: #da3734; font-size: 12px; margin-top: 4px"
                  >
                    {{ fileUploadErrors.NatureOFBusiness }}
                  </div>

                  <input
                    type="file"
                    id="NatureOFBusiness"
                    required
                    accept=".pdf,.jpeg,.jpg,.png"
                    multiple
                    ref="NatureOFBusiness"
                    class="file-input"
                    @change="handleFileChange($event, 'NatureOFBusiness')"
                    v-if="!uploadedNatureOFBusiness"
                  />
                </div>
              </div>

              <!-- Board of RF -->
              <div style="margin-bottom: 20px">
                <div style="font-weight: bold">Board of Resolution Form</div>
                <div
                  class="file-upload-section"
                  style="font-size: 12px; background-color: #f8f9fc"
                >
                  <label for="BoardofRF" class="upload-label">
                    <div class="upload-icon">
                      <!-- Upload Icon (You can replace this with your SVG or icon) -->
                      <img
                        src="@/components/img/Sales_Assests/uploadicon.svg"
                        alt="Upload Icon"
                      />
                    </div>
                    <div class="upload-text">
                      <div v-if="uploadedBoardofRF">
                        {{ uploadedBoardofRF.file.name }}
                        <span
                          class="ml-3"
                          aria-hidden="true"
                          @click="removeFileBoardofRF"
                          style="color: #da3734; font-size: 14px"
                          >&times;</span
                        >
                      </div>
                      <div v-else>
                        <div>Upload Board of Resolution Form</div>
                        <div class="small-text">
                          Supports JPG, PNG, PDF files only. Max size - 1.75MB
                        </div>
                        <div
                          class="small-text"
                          style="color: #db8c09; font-weight: bold"
                        >
                          Make sure the uploaded document is the edited version
                          of the downloaded template.
                        </div>
                      </div>
                    </div>
                  </label>

                  <div
                    v-if="fileUploadErrors.BoardofRF"
                    style="color: #da3734; font-size: 12px; margin-top: 4px"
                  >
                    {{ fileUploadErrors.BoardofRF }}
                  </div>

                  <input
                    type="file"
                    id="BoardofRF"
                    required
                    accept=".pdf,.jpeg,.jpg,.png"
                    multiple
                    ref="BoardofRF"
                    class="file-input"
                    @change="handleFileChange($event, 'BoardofRF')"
                    v-if="!uploadedBoardofRF"
                  />
                </div>
              </div>

              <!-- NDA -->
              <div style="margin-bottom: 20px">
                <div style="font-weight: bold">
                  Non-Disclosure Agreement Form
                </div>
                <div
                  class="file-upload-section"
                  style="font-size: 12px; background-color: #f8f9fc"
                >
                  <label for="NDA" class="upload-label">
                    <div class="upload-icon">
                      <!-- Upload Icon (You can replace this with your SVG or icon) -->
                      <img
                        src="@/components/img/Sales_Assests/uploadicon.svg"
                        alt="Upload Icon"
                      />
                    </div>
                    <div class="upload-text">
                      <div v-if="uploadedNDA">
                        {{ uploadedNDA.file.name }}
                        <span
                          class="ml-3"
                          aria-hidden="true"
                          @click="removeFileNDA"
                          style="color: #da3734; font-size: 14px"
                          >&times;</span
                        >
                      </div>
                      <div v-else>
                        <div>Upload Non-Disclosure Agreement Form</div>
                        <div class="small-text">
                          Supports JPG, PNG, PDF files only. Max size - 1.75MB
                        </div>
                        <div
                          class="small-text"
                          style="color: #db8c09; font-weight: bold"
                        >
                          Make sure the uploaded document is the edited version
                          of the downloaded template.
                        </div>
                      </div>
                    </div>
                  </label>

                  <div
                    v-if="fileUploadErrors.NDA"
                    style="color: #da3734; font-size: 12px; margin-top: 4px"
                  >
                    {{ fileUploadErrors.NDA }}
                  </div>

                  <input
                    type="file"
                    id="NDA"
                    required
                    accept=".pdf,.jpeg,.jpg,.png"
                    multiple
                    ref="NDA"
                    class="file-input"
                    @change="handleFileChange($event, 'NDA')"
                    v-if="!uploadedNDA"
                  />
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <div class="Save-button" @click="saveAndContinue(2)">
                Save & Continue Later
              </div>
              <div class="previous-button" @click="previousModal1">
                Previous
              </div>
              <button class="onboardNext-button" type="submit">Next</button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  </div>

  <!-- Onboarding Modal3 -->
  <div class="modal-overlay" v-show="showOnboardingModal3">
    <Modal
      class="custom-modal custom-modal-width2"
      v-show="showOnboardingModal3"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div v-if="SE_DNSA != 1" class="modal1 mt-2"></div>
            <div class="modal1 mt-2 ml-2"></div>
            <div class="modal1 mt-2 ml-2"></div>
            <div class="modal1 mt-2 ml-2"></div>
            <div
              class="modal1 mt-2 ml-2"
              style="background-color: #f1f3f9"
            ></div>
            <div
              class="modal1 mt-2 ml-2"
              style="background-color: #f1f3f9"
            ></div>
            <div
              class="modal1 mt-2 ml-2"
              style="background-color: #f1f3f9"
            ></div>
            <div
              class="modal1 mt-2 ml-2"
              style="background-color: #f1f3f9"
            ></div>
            <button type="button" class="close" @click="CloseModal(3)">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-header">
            <div class="modal-header-container">
              <div class="modal-header-text2">
                NIN & BVN Verification <br />
                <div class="modal-text3">
                  Please provide all information requested below in order to
                </div>
                <div class="modal-text3">
                  create a business account for your client.
                </div>
              </div>
            </div>
          </div>

          <form @submit.prevent="openOnboardingModal4">
            <div class="modal-body modal-body9 modal-text">
              <!-- First Name -->
              <div class="form-group">
                <label for="firstName">First Name</label>
                <input
                  type="text"
                  id="firstName"
                  required
                  class="form-control"
                  v-model="firstName"
                  placeholder="Enter First Name"
                  style="font-size: 12px; background-color: #f8f9fc"
                />
              </div>

              <!-- Last Name -->
              <div class="form-group">
                <label for="lastName">Last Name</label>
                <input
                  type="text"
                  id="lastName"
                  required
                  class="form-control"
                  v-model="lastName"
                  placeholder="Enter Last Name"
                  style="font-size: 12px; background-color: #f8f9fc"
                />
              </div>

              <!-- NIN Number -->
              <div class="form-group">
                <label for="NIN">NIN </label>
                <input
                  type="text"
                  id="NIN"
                  maxlength="11"
                  @input="onInputNIN"
                  required
                  class="form-control"
                  :disabled="isNINDisabled"
                  v-model="NIN"
                  placeholder="Enter your NIN"
                  style="font-size: 12px; background-color: #f8f9fc"
                />
                <div class="password-toggle">
                  <!-- <div v-if="NIN.length == 11">
                  <div v-if="VerifiedNIN">
                <img src="@/components/img/Sales_Assests/check-circle.svg" style="height: 20px; width:auto" alt="CheckIcon Icon">
              </div>
              <div v-else-if="!loading && !VerifiedNIN">
                <img src="@/components/img/Sales_Assests/x-circle.svg" style="height: 20px; width:auto" alt="CheckIcon Icon">
              </div>
            </div> -->
                </div>
              </div>
              <!-- <div v-if="errorNINMessage" class="alert alert-danger" role="alert">
            {{ errorNINMessage }}
          </div> -->

              <!-- BVN Number -->
              <div class="form-group">
                <label for="BVN"
                  >BVN
                  <span
                    v-if="!firstName || !lastName"
                    style="font-size: 10px; margin-left: 185px"
                    >Note: First Name & Last Name are Required
                  </span>
                </label>
                <input
                  type="text"
                  id="BVN"
                  maxlength="11"
                  @input="onInputBVN"
                  required
                  class="form-control"
                  v-model="BVN"
                  placeholder="Enter your BVN"
                  style="font-size: 12px; background-color: #f8f9fc"
                />
                <div class="password-toggle">
                  <div v-if="BVN.length == 11">
                    <div v-if="loadingBVN">
                      <i class="fa fa-spinner fa-spin"></i>
                    </div>
                    <div v-else-if="!loadingBVN && VerifiedBVN">
                      <img
                        src="@/components/img/Sales_Assests/check-circle.svg"
                        style="height: 20px; width: auto"
                        alt="CheckIcon Icon"
                      />
                    </div>
                    <div v-else-if="!loadingBVN && !VerifiedBVN">
                      <img
                        src="@/components/img/Sales_Assests/x-circle.svg"
                        style="height: 20px; width: auto"
                        alt="CheckIcon Icon"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="errorBVNMessage"
                class="alert alert-danger"
                role="alert"
              >
                {{ errorBVNMessage }}
              </div>

              <div
                v-if="errorVerificationMessage"
                class="alert alert-danger"
                role="alert"
              >
                {{ errorVerificationMessage }}
              </div>
            </div>

            <div class="modal-footer">
              <div class="Save-button" @click="saveAndContinue(3)">
                Save & Continue Later
              </div>
              <div class="previous-button" @click="previousModal2">
                Previous
              </div>
              <button class="onboardNext-button" type="submit">Next</button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  </div>

  <!-- Onboarding Modal4 -->
  <div class="modal-overlay" v-show="showOnboardingModal4">
    <Modal
      class="custom-modal custom-modal-width2"
      v-show="showOnboardingModal4"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div v-if="SE_DNSA != 1" class="modal1 mt-2"></div>
            <div class="modal1 mt-2 ml-2"></div>
            <div class="modal1 mt-2 ml-2"></div>
            <div class="modal1 mt-2 ml-2"></div>
            <div class="modal1 mt-2 ml-2"></div>
            <div
              class="modal1 mt-2 ml-2"
              style="background-color: #f1f3f9"
            ></div>
            <div
              class="modal1 mt-2 ml-2"
              style="background-color: #f1f3f9"
            ></div>
            <div
              class="modal1 mt-2 ml-2"
              style="background-color: #f1f3f9"
            ></div>
            <button type="button" class="close" @click="CloseModal(4)">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-header">
            <div class="modal-header-container">
              <div class="modal-header-text2">
                Bank Details <br />
                <div class="modal-text3">
                  Please provide all information requested below in order to
                </div>
                <div class="modal-text3">
                  create a business account for your client.
                </div>
              </div>
            </div>
          </div>

          <form @submit.prevent="openOnboardingModal5">
            <div class="modal-body modal-body9 modal-text">
              <!-- Account Number-->
              <div class="form-group">
                <label for="acctNumber">Account Number</label>
                <input
                  type="text"
                  id="acctNumber"
                  class="form-control"
                  required
                  maxlength="10"
                  @input="onInputAcct"
                  v-model="acctNumber"
                  placeholder="Enter account number"
                  style="font-size: 12px; background-color: #f8f9fc"
                />
              </div>

              <!-- Banks -->
              <div class="form-group">
                <label for="bank">Bank</label>
                <div class="dropdown-container">
                  <select
                    id="bank"
                    class="form-control"
                    v-model="selectedBankCode"
                    ref="dropdown"
                    style="font-size: 12px; background-color: #f8f9fc"
                    required
                  >
                    <option value="" disabled selected>Select Bank</option>
                    <option
                      v-for="bank in banks"
                      :key="bank.code"
                      :value="bank.code"
                    >
                      {{ bank.name }}
                    </option>
                  </select>

                  <!-- <div class="dropdown-icon-container" >
                <img src="@/components/img/Sales_Assests/dropdown.svg" alt="Dropdown Icon" @click="toggleDropdown">
              </div> -->
                </div>
              </div>

              <!-- Account Inquiry -->
              <div class="form-group">
                <label for="acctName">Account Name</label>
                <input
                  type="text"
                  id="acctName"
                  class="form-control"
                  required
                  v-model="acctName"
                  disabled
                  style="font-size: 12px; background-color: #f8f9fc"
                />
                <div class="password-toggle">
                  <div v-if="loadingAcct">
                    <i class="fa fa-spinner fa-spin"></i>
                  </div>
                </div>
              </div>
              <div
                v-if="errorAcctMessage"
                class="alert alert-danger"
                role="alert"
              >
                {{ errorAcctMessage }}
              </div>

              <!-- Type Dropdown -->
              <div class="form-group">
                <label for="TransactionMax">Maximum Single Transaction:</label>
                <div class="dropdown-container">
                  <select
                    id="TransactionMax"
                    class="form-control"
                    v-model="TransactionMax"
                    ref="TransactionMax"
                    style="
                      font-size: 12px;
                      background-color: transparent;
                      cursor: pointer;
                      z-index: 2;
                    "
                    required
                  >
                    <option value="" disabled selected>
                      Select Transaction
                    </option>
                    <option value="Above 5 million Naira">
                      Above 5 million Naira
                    </option>
                    <option value="Below 5 million Naira">
                      Below 5 million Naira
                    </option>
                  </select>
                  <img
                    class="dropdown-icon"
                    src="@/components/img/Sales_Assests/dropdown.svg"
                    alt="Dropdown Icon"
                  />
                </div>
              </div>

              <span
                v-if="TransactionMax == 'Above 5 million Naira'"
                class="mt-2"
                style="
                  font-size: 12px;
                  color: #6f48ff;
                  display: flex;
                  cursor: pointer;
                "
                @click="downloadFile('IndemnityFORM')"
              >
                <strong style="color: #6f48ff"
                  >Download Indemnity Form Template</strong
                >
                <img
                  class="custom-icon ml-1"
                  src="@/components/img/Sales_Assests/download-icon.svg"
                  alt="Custom Icon"
                />
              </span>

              <!-- Upload Indemnity -->
              <div
                v-if="TransactionMax == 'Above 5 million Naira'"
                class="file-upload-section"
                style="font-size: 12px; background-color: #f8f9fc"
              >
                <label for="indemnity" class="upload-label">
                  <div class="upload-icon">
                    <!-- Upload Icon (You can replace this with your SVG or icon) -->
                    <img
                      src="@/components/img/Sales_Assests/uploadicon.svg"
                      alt="Upload Icon"
                    />
                  </div>
                  <div class="upload-text">
                    <div v-if="uploadedIndemnity">
                      {{ uploadedIndemnity.file.name }}
                      <span
                        class="ml-3"
                        aria-hidden="true"
                        @click="removeFileIndemnity"
                        style="color: #da3734; font-size: 14px"
                        >&times;</span
                      >
                    </div>
                    <div v-else>
                      <div>Upload your Indemnity Form</div>
                      <div class="small-text">
                        Supports JPG, PNG, PDF files only. Max size - 1.75MB
                      </div>
                    </div>
                  </div>
                </label>

                <div
                  v-if="fileUploadErrors.indemnity"
                  style="color: #da3734; font-size: 12px; margin-top: 4px"
                >
                  {{ fileUploadErrors.indemnity }}
                </div>

                <input
                  type="file"
                  id="indemnity"
                  ref="indemnity"
                  required
                  accept=".pdf,.jpeg,.jpg,.png"
                  multiple
                  class="file-input"
                  @change="handleFileChange($event, 'indemnity')"
                  v-if="!uploadedIndemnity"
                />
              </div>
            </div>

            <div class="modal-footer">
              <div class="Save-button" @click="saveAndContinue(4)">
                Save & Continue Later
              </div>
              <div class="previous-button" @click="previousModal3">
                Previous
              </div>
              <button class="onboardNext-button" type="submit">Next</button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  </div>

  <!-- Onboarding Modal5 -->
  <div class="modal-overlay" v-show="showOnboardingModal5">
    <Modal
      class="custom-modal custom-modal-width2"
      v-show="showOnboardingModal5"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div v-if="SE_DNSA != 1" class="modal1 mt-2"></div>
            <div class="modal1 mt-2 ml-2"></div>
            <div class="modal1 mt-2 ml-2"></div>
            <div class="modal1 mt-2 ml-2"></div>
            <div class="modal1 mt-2 ml-2"></div>
            <div class="modal1 mt-2 ml-2"></div>
            <div
              class="modal1 mt-2 ml-2"
              style="background-color: #f1f3f9"
            ></div>
            <div
              class="modal1 mt-2 ml-2"
              style="background-color: #f1f3f9"
            ></div>
            <button type="button" class="close" @click="CloseModal(5)">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-header">
            <div class="modal-header-container">
              <div class="modal-header-text2">
                Location Details <br />
                <div class="modal-text3">
                  Please provide all information requested below in order to
                </div>
                <div class="modal-text3">
                  create a business account for your client.
                </div>
              </div>
            </div>
          </div>
          <div class="location-modal">
            <div
              v-for="(location, index) in locationList"
              :key="index"
              class="location-card"
            >
              <div class="list-number">{{ index + 1 }}</div>
              <div class="location-details">
                <div class="detail">
                  Location Name:
                  <strong class="mr-3">
                    {{
                      location.name.length > 7
                        ? location.name.substring(0, 7) + "..."
                        : location.name
                    }}</strong
                  >
                  Location Address:
                  <strong>
                    {{
                      location.address.length > 3
                        ? location.address.substring(0, 3) + "..."
                        : location.address
                    }}</strong
                  >
                </div>
              </div>
              <div class="edit-text" @click="editLocation(index)">
                <strong class="edit-text">Edit</strong>
              </div>
            </div>
          </div>

          <form @submit.prevent="addLocation">
            <div
              :class="{
                'modal-body9': locationList.length === 0,
                'modal-body10': locationList.length === 1,
                'modal-body11': locationList.length > 1,
              }"
              class="modal-body modal-text"
            >
              <div
                v-if="errorLocationMessage"
                class="alert alert-danger"
                role="alert"
              >
                {{ errorLocationMessage }}
              </div>

              <div v-show="LocationForm">
                <!-- Location Name -->
                <div class="form-group">
                  <label for="locationName">Location Name</label>
                  <div class="dropdown-container">
                    <input
                      type="text"
                      id="locationName"
                      class="form-control"
                      v-model="locationName"
                      placeholder="Enter location name"
                      style="font-size: 12px; background-color: #f8f9fc"
                    /><br />
                  </div>
                  <div class="modal-text3">E.g Town or City</div>
                </div>

                <!-- Location Address -->
                <div class="form-group">
                  <label for="locationAddress">Location Address</label>
                  <div class="dropdown-container">
                    <input
                      type="text"
                      id="locationAddress"
                      class="form-control"
                      v-model="locationAddress"
                      placeholder="Enter location address"
                      style="font-size: 12px; background-color: #f8f9fc"
                    /><br />
                  </div>
                  <div class="modal-text3">E.g house number and street</div>
                </div>

                <!-- State -->
                <div class="form-group">
                  <label for="state">State</label>
                  <div class="dropdown-container">
                    <select
                      id="state"
                      class="form-control"
                      v-model="selectedState"
                      @change="updateLGAs"
                      style="font-size: 12px; background-color: #f8f9fc"
                    >
                      <option value="" disabled selected>Select state</option>
                      <option
                        v-for="state in states"
                        :key="state.id"
                        :value="state.id"
                      >
                        {{ state.name }}
                      </option>
                    </select>
                    <div class="dropdown-icon-container">
                      <img
                        src="@/components/img/Sales_Assests/dropdown.svg"
                        alt="Dropdown Icon"
                        @click="toggleDropdown"
                      />
                    </div>
                  </div>
                </div>

                <!-- LGA -->
                <div class="form-group">
                  <label for="lga">LGA</label>
                  <div class="dropdown-container">
                    <select
                      id="lga"
                      class="form-control"
                      v-model="selectedLGA"
                      @change="getLGAName"
                      style="font-size: 12px; background-color: #f8f9fc"
                    >
                      <option value="" disabled selected>Select LGA</option>
                      <option
                        v-for="lga in selectedStateLGAs"
                        :key="lga.id"
                        :value="lga.id"
                      >
                        {{ lga.name }}
                      </option>
                    </select>
                    <div class="dropdown-icon-container">
                      <img
                        src="@/components/img/Sales_Assests/dropdown.svg"
                        alt="Dropdown Icon"
                        @click="toggleDropdown"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="!LocationForm">
                <div style="margin-top: 180px; width: auto"></div>
              </div>

              <div class="add-location-button" @click="LocationForm = true">
                <div
                  style="
                    border-color: transparent;
                    background-color: transparent;
                    width: 100%;
                    margin-right: auto;
                    padding: 0px;
                  "
                >
                  <img
                    class="add-location-button"
                    src="@/components/img/Sales_Assests/AddLocationButton.svg"
                    alt="Add Location Button"
                  />
                </div>
              </div>

              <div
                class="button-container"
                style="margin-top: 10px; width: auto"
              >
                <button
                  type="submit"
                  class="onboard-button2"
                  style="width: 100%; height: 40px"
                >
                  Save Location
                </button>
              </div>
            </div>

            <div class="modal-footer">
              <div class="Save-button" @click="saveAndContinue(5)">
                Save & Continue Later
              </div>
              <div class="previous-button" @click="previousModal4">
                Previous
              </div>
              <div class="onboardNext-button" @click="openOnboardingModal6">
                Next
              </div>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  </div>

  <!-- Onboarding Modal6 -->
  <div class="modal-overlay" v-show="showOnboardingModal6">
    <Modal
      class="custom-modal custom-modal-width2"
      v-show="showOnboardingModal6"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div v-if="SE_DNSA != 1" class="modal1 mt-2"></div>
            <div class="modal1 mt-2 ml-2"></div>
            <div class="modal1 mt-2 ml-2"></div>
            <div class="modal1 mt-2 ml-2"></div>
            <div class="modal1 mt-2 ml-2"></div>
            <div class="modal1 mt-2 ml-2"></div>
            <div class="modal1 mt-2 ml-2"></div>
            <div
              class="modal1 mt-2 ml-2"
              style="background-color: #f1f3f9"
            ></div>
            <button type="button" class="close" @click="CloseModal(6)">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-header">
            <div class="modal-header-container">
              <div class="modal-header-text2">
                Cashier <br />
                <div class="modal-text3">
                  Please provide all information requested below in order to
                </div>
                <div class="modal-text3">
                  create a business account for your client.
                </div>
              </div>
            </div>
          </div>
          <div class="location-modal">
            <div
              v-for="(cashier, index) in cashierList"
              :key="index"
              class="location-card"
            >
              <div class="list-number">{{ index + 1 }}</div>
              <div class="location-details">
                <div class="detail">
                  First Name:
                  <strong class="mr-3">
                    {{
                      cashier.firstname.length > 7
                        ? cashier.firstname.substring(0, 7) + "..."
                        : cashier.firstname
                    }}</strong
                  >
                  Last Name:
                  <strong>
                    {{
                      cashier.lastname.length > 3
                        ? cashier.lastname.substring(0, 3) + "..."
                        : cashier.lastname
                    }}</strong
                  >
                </div>
              </div>
              <div class="edit-text" @click="editCashier(index)">
                <strong class="edit-text">Edit</strong>
              </div>
            </div>
          </div>

          <form @submit.prevent="addCashier">
            <div
              :class="{
                'modal-body9': cashierList.length === 0,
                'modal-body10': cashierList.length === 1,
                'modal-body11': cashierList.length > 1,
              }"
              class="modal-body modal-text"
            >
              <div
                v-if="errorCashierMessage"
                class="alert alert-danger"
                role="alert"
              >
                {{ errorCashierMessage }}
              </div>

              <div v-show="CashierForm">
                <!-- Location Name -->
                <div class="form-group">
                  <label for="location">Location</label>
                  <div class="dropdown-container">
                    <select
                      id="cashierlocation"
                      class="form-control"
                      v-model="cashierlocation"
                      ref="cashierlocation"
                      @click="toggleDropdown"
                      style="font-size: 12px; background-color: #f8f9fc"
                    >
                      <option value="" disabled selected>
                        Select Location
                      </option>
                      <option
                        v-for="(location, index) in locationList"
                        :key="index"
                        :value="location.name"
                      >
                        {{ location.name }}
                      </option>
                    </select>
                    <!-- <div class="dropdown-icon-container">
                <img src="@/components/img/Sales_Assests/dropdown.svg" alt="Dropdown Icon" @click="toggleDropdown">
              </div> -->
                  </div>
                </div>

                <!-- Cashier First Name -->
                <div class="form-group">
                  <label for="CashierFirstName">First Name</label>
                  <input
                    type="text"
                    id="CashierFirstName"
                    required
                    class="form-control"
                    v-model="CashierFirstName"
                    placeholder="Enter First Name"
                    style="font-size: 12px; background-color: #f8f9fc"
                  />
                </div>

                <!-- Cashier Last Name -->
                <div class="form-group">
                  <label for="CashierLastName">Last Name</label>
                  <input
                    type="text"
                    id="CashierLastName"
                    required
                    class="form-control"
                    v-model="CashierLastName"
                    placeholder="Enter Last Name"
                    style="font-size: 12px; background-color: #f8f9fc"
                  />
                </div>

                <!-- Cashier Phone Number -->
                <div class="form-group">
                  <label for="CashierPhoneNumber">Phone Number</label>
                  <input
                    type="text"
                    id="CashierPhoneNumber"
                    required
                    class="form-control"
                    maxlength="11"
                    @input="onCashierPhoneInput"
                    v-model="CashierPhoneNumber"
                    placeholder="Enter cashier phone number"
                    style="font-size: 12px; background-color: #f8f9fc"
                  />
                </div>

                <!-- Cashier Email -->
                <div class="form-group">
                  <label for="cashierEmail">Email Address</label>
                  <input
                    type="tel"
                    id="cashierEmail"
                    required
                    class="form-control"
                    v-model="cashierEmail"
                    placeholder="Enter cashier email address"
                    style="font-size: 12px; background-color: #f8f9fc"
                  />
                </div>
              </div>

              <div v-if="!CashierForm">
                <div style="margin-top: 180px; width: auto"></div>
              </div>

              <div
                class="add-location-button"
                @click="CashierForm = true"
                style="
                  border-color: transparent;
                  background-color: transparent;
                  width: 100%;
                  margin-right: auto;
                  padding: 0px;
                "
              >
                <img
                  class="add-location-button"
                  src="@/components/img/Sales_Assests/AddCashierButton.svg"
                  alt="Add Location Button"
                />
              </div>

              <div
                class="button-container"
                style="margin-top: 10px; width: auto"
              >
                <button
                  type="submit"
                  class="onboard-button2"
                  style="width: 100%; height: 40px"
                >
                  Save Cashier
                </button>
              </div>
            </div>

            <div class="modal-footer">
              <div class="Save-button" @click="saveAndContinue(6)">
                Save & Continue Later
              </div>
              <div class="previous-button" @click="previousModal5">
                Previous
              </div>
              <div class="onboardNext-button" @click="openOnboardingModal7">
                Next
              </div>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  </div>

  <!-- Preview and submit Modal -->
  <div class="modal-overlay" v-show="showOnboardingModal7">
    <Modal
      class="custom-modal custom-modal-width2"
      v-show="showOnboardingModal7"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div v-if="SE_DNSA != 1" class="modal1 mt-2"></div>
            <div class="modal1 mt-2 ml-2"></div>
            <div class="modal1 mt-2 ml-2"></div>
            <div class="modal1 mt-2 ml-2"></div>
            <div class="modal1 mt-2 ml-2"></div>
            <div class="modal1 mt-2 ml-2"></div>
            <div class="modal1 mt-2 ml-2"></div>
            <div class="modal1 mt-2 ml-2"></div>
            <button type="button" class="close" @click="closeOnboardingModal7">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-header">
            <div class="modal-header-container">
              <div class="modal-header-text2">
                Preview & Submit <br />
                <div class="modal-text3">
                  Please preview all information provided before you submit.
                </div>
              </div>
            </div>
          </div>

          <div class="modal-body modal-body9 modal-text">
            <div class="preview-section">
              <div class="preview-section-header">
                <div class="preview-section-text mb-3">
                  Business Information
                </div>
                <div class="edit-icon-container" @click="editModal1">
                  <img
                    src="@/components/img/Sales_Assests/edit.svg"
                    alt="Edit Icon"
                  />
                  <div
                    class="edit-text"
                    style="color: #6f48ff; font-size: 14px"
                  >
                    Edit
                  </div>
                </div>
              </div>

              <div class="preview-item mb-1">
                <div class="label">Type:</div>
                <div class="value">{{ businessType }}</div>
              </div>
              <div class="preview-item mb-1">
                <div class="label">Business Name:</div>
                <div class="value">{{ businessName }}</div>
              </div>
              <div class="preview-item mb-1">
                <div class="label">Email Address</div>
                <div class="value">{{ email }}</div>
              </div>
              <div class="preview-item mb-1">
                <div class="label">Tax Identification Number</div>
                <div class="value">{{ taxNumber }}</div>
              </div>
            </div>
            <br />

            <div class="preview-section">
              <div class="preview-section-header">
                <div class="preview-section-text mb-3">Business Documents</div>
                <div class="edit-icon-container" @click="editModal2">
                  <img
                    src="@/components/img/Sales_Assests/edit.svg"
                    alt="Edit Icon"
                  />
                  <div
                    class="edit-text"
                    style="color: #6f48ff; font-size: 14px"
                  >
                    Edit
                  </div>
                </div>
              </div>
              <div class="preview-item mb-1">
                <div class="label">Government Issued ID Type</div>
                <div class="value">{{ GovID }}</div>
              </div>
              <div class="preview-item mb-1">
                <div class="label">ID Number</div>
                <div class="value">{{ IDType }}</div>
              </div>
              <!--Govt Issued ID-->
              <div class="preview-item mb-1">
                <div class="label">Uploaded Government ID</div>
                <div class="value">
                  <div v-if="uploadedFile">
                    <img
                      src="@/components/img/Sales_Assests/pdf-icon.svg"
                      alt="PDF Icon"
                    />
                    {{ uploadedFile.file.name }}
                  </div>
                  <div v-else>
                    <div>Govt. issued ID</div>
                  </div>
                </div>
              </div>
              <!--Utility bill-->
              <div class="preview-item mb-1">
                <div class="label">Utility bill</div>
                <div class="value">
                  <div v-if="uploadedUtilityBill">
                    <img
                      src="@/components/img/Sales_Assests/pdf-icon.svg"
                      alt="PDF Icon"
                    />
                    {{ uploadedUtilityBill.file.name }}
                  </div>
                  <div v-else>
                    <div>Utility Bill</div>
                  </div>
                </div>
              </div>

              <!--Tin Slip-->
              <div class="preview-item mb-1">
                <div class="label">TIN Slip</div>
                <div class="value">
                  <div v-if="uploadedTinSlip">
                    <img
                      src="@/components/img/Sales_Assests/pdf-icon.svg"
                      alt="PDF Icon"
                    />
                    {{ uploadedTinSlip.file.name }}
                  </div>
                  <div v-else>
                    <div>TIN Slip</div>
                  </div>
                </div>
              </div>

              <div class="preview-item mb-1">
                <div class="label">MEMART</div>
                <div class="value">
                  <div v-if="uploadedMEMART">
                    <img
                      src="@/components/img/Sales_Assests/pdf-icon.svg"
                      alt="PDF Icon"
                    />
                    {{ uploadedMEMART.file.name }}
                  </div>
                  <div v-else>
                    <div>MEMART</div>
                  </div>
                </div>
              </div>

              <div class="preview-item mb-1">
                <div class="label">Status Report</div>
                <div class="value">
                  <div v-if="uploadedStatusReport">
                    <img
                      src="@/components/img/Sales_Assests/pdf-icon.svg"
                      alt="PDF Icon"
                    />
                    {{ uploadedStatusReport.file.name }}
                  </div>
                  <div v-else>
                    <div>Status Report</div>
                  </div>
                </div>
              </div>

              <div class="preview-item mb-1">
                <div class="label">Letter of Introduction</div>
                <div class="value">
                  <div v-if="uploadedLetterOfIntro">
                    <img
                      src="@/components/img/Sales_Assests/pdf-icon.svg"
                      alt="PDF Icon"
                    />
                    {{ uploadedLetterOfIntro.file.name }}
                  </div>
                  <div v-else>
                    <div>Letter of Introduction</div>
                  </div>
                </div>
              </div>

              <div class="preview-item mb-1">
                <div class="label">Company Profile</div>
                <div class="value">
                  <div v-if="uploadedCompanyProfile">
                    <img
                      src="@/components/img/Sales_Assests/pdf-icon.svg"
                      alt="PDF Icon"
                    />
                    {{ uploadedCompanyProfile.file.name }}
                  </div>
                  <div v-else>
                    <div>Company Profile</div>
                  </div>
                </div>
              </div>

              <div class="preview-item mb-1">
                <div class="label">Nature of Business Form</div>
                <div class="value">
                  <div v-if="uploadedNatureOFBusiness">
                    <img
                      src="@/components/img/Sales_Assests/pdf-icon.svg"
                      alt="PDF Icon"
                    />
                    {{ uploadedNatureOFBusiness.file.name }}
                  </div>
                  <div v-else>
                    <div>Nature of Business Form</div>
                  </div>
                </div>
              </div>

              <div class="preview-item mb-1">
                <div class="label">Board of Resolution Form</div>
                <div class="value">
                  <div v-if="uploadedBoardofRF">
                    <img
                      src="@/components/img/Sales_Assests/pdf-icon.svg"
                      alt="PDF Icon"
                    />
                    {{ uploadedBoardofRF.file.name }}
                  </div>
                  <div v-else>
                    <div>Board of Resolution Form</div>
                  </div>
                </div>
              </div>

              <div class="preview-item mb-1">
                <div class="label">Non-Disclosure Agreement Form</div>
                <div class="value">
                  <div v-if="uploadedNDA">
                    <img
                      src="@/components/img/Sales_Assests/pdf-icon.svg"
                      alt="PDF Icon"
                    />
                    {{ uploadedNDA.file.name }}
                  </div>
                  <div v-else>
                    <div>Board of Resolution Form</div>
                  </div>
                </div>
              </div>

              <div class="preview-item mb-1">
                <div class="label">Business Registration Code</div>
                <div class="value">{{ RegCode }}</div>
              </div>
              <div class="preview-item mb-1">
                <div class="label">C.A.C Document</div>
                <div class="value">
                  <div v-if="uploadedCAC">
                    <img
                      src="@/components/img/Sales_Assests/pdf-icon.svg"
                      alt="PDF Icon"
                    />
                    {{ uploadedCAC.file.name }}
                  </div>
                  <div v-else>
                    <div>C.A.C Document</div>
                  </div>
                </div>
              </div>
            </div>
            <br />

            <div class="preview-section">
              <div class="preview-section-header">
                <div class="preview-section-text mb-3">NIN & BVN Details</div>
                <div class="edit-icon-container" @click="editModal3">
                  <img
                    src="@/components/img/Sales_Assests/edit.svg"
                    alt="Edit Icon"
                  />
                  <div
                    class="edit-text"
                    style="color: #6f48ff; font-size: 14px"
                  >
                    Edit
                  </div>
                </div>
              </div>
              <div class="preview-item mb-1">
                <div class="label">First Name</div>
                <div class="value">{{ firstName }}</div>
              </div>
              <div class="preview-item mb-1">
                <div class="label">Last Name</div>
                <div class="value">{{ lastName }}</div>
              </div>
              <div class="preview-item mb-1">
                <div class="label">NIN</div>
                <div class="value">
                  <img
                    src="@/components/img/Sales_Assests/checkmark.svg"
                    alt="Checkmark Icon"
                    class="checkmark-icon"
                  />
                  {{ NIN }}
                </div>
              </div>
              <div class="preview-item mb-1">
                <div class="label">BVN</div>
                <div class="value">
                  <img
                    src="@/components/img/Sales_Assests/checkmark.svg"
                    alt="Checkmark Icon"
                    class="checkmark-icon"
                  />
                  {{ BVN }}
                </div>
              </div>
              <div class="preview-item mb-1">
                <div class="label">Phone Number</div>
                <div class="value">{{ phoneNumber }}</div>
              </div>
            </div>
            <br />

            <div class="preview-section">
              <div class="preview-section-header">
                <div class="preview-section-text mb-3">Bank Details</div>
                <div class="edit-icon-container" @click="editModal4">
                  <img
                    src="@/components/img/Sales_Assests/edit.svg"
                    alt="Edit Icon"
                  />
                  <div
                    class="edit-text"
                    style="color: #6f48ff; font-size: 14px"
                  >
                    Edit
                  </div>
                </div>
              </div>
              <div class="preview-item mb-1">
                <div class="label">Account Number</div>
                <div class="value">{{ acctNumber }}</div>
              </div>
              <div class="preview-item mb-1">
                <div class="label">Bank</div>
                <div class="value">{{ selectedBankName }}</div>
              </div>
              <div class="preview-item mb-1">
                <div class="label">Account Name</div>
                <div class="value">{{ acctName }}</div>
              </div>

              <!--Indemnity Form-->
              <div
                v-if="TransactionMax == 'Above 5 million Naira'"
                class="preview-item mb-1"
              >
                <div class="label">Indemnity Form</div>
                <div class="value">
                  <div v-if="uploadedIndemnity">
                    <img
                      src="@/components/img/Sales_Assests/pdf-icon.svg"
                      alt="PDF Icon"
                    />
                    {{ uploadedIndemnity.file.name }}
                  </div>
                  <div v-else>
                    <div>Indemnity Form</div>
                  </div>
                </div>
              </div>
            </div>
            <br />

            <div class="preview-section">
              <div class="preview-section-header">
                <div class="preview-section-text mb-3">Location Details</div>
                <div class="edit-icon-container" @click="editModal5">
                  <img
                    src="@/components/img/Sales_Assests/edit.svg"
                    alt="Edit Icon"
                  />
                  <div
                    class="edit-text"
                    style="color: #6f48ff; font-size: 14px"
                  >
                    Edit
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div
                  v-for="(location, index) in locationList"
                  :key="index"
                  class="location-card"
                >
                  <div class="list-number">{{ index + 1 }}</div>
                  <div class="location-details">
                    <div class="detail">
                      Location Name:
                      <strong class="mr-3">
                        {{
                          location.name.length > 7
                            ? location.name.substring(0, 7) + "..."
                            : location.name
                        }}</strong
                      >
                      Location Address:
                      <strong>
                        {{
                          location.address.length > 3
                            ? location.address.substring(0, 3) + "..."
                            : location.address
                        }}</strong
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="preview-section">
              <div class="preview-section-header">
                <div class="preview-section-text mb-3">Cashiers</div>
                <div class="edit-icon-container" @click="editModal6">
                  <img
                    src="@/components/img/Sales_Assests/edit.svg"
                    alt="Edit Icon"
                  />
                  <div
                    class="edit-text"
                    style="color: #6f48ff; font-size: 14px"
                  >
                    Edit
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div
                  v-for="(cashier, index) in cashierList"
                  :key="index"
                  class="location-card"
                >
                  <div class="list-number">{{ index + 1 }}</div>
                  <div class="location-details">
                    <div class="detail">
                      First Name:
                      <strong class="mr-3">
                        {{
                          cashier.firstname.length > 7
                            ? cashier.firstname.substring(0, 7) + "..."
                            : cashier.firstname
                        }}</strong
                      >
                      Last Name:
                      <strong>
                        {{
                          cashier.lastname.length > 3
                            ? cashier.lastname.substring(0, 3) + "..."
                            : cashier.lastname
                        }}</strong
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <div class="Save-button" @click="saveAndContinue(7)">
              Save & Continue Later
            </div>
            <div class="previous-button" @click="previousModal6">Previous</div>
            <div class="onboardNext-button" @click="submitOnboarding">
              Submit
            </div>
          </div>
        </div>
      </div>
    </Modal>
  </div>

  <!-- Success Modal -->
  <div class="modal-overlay" v-show="showOnboardingSuccess">
    <Modal
      class="custom-modal custom-modal-width"
      v-show="showOnboardingSuccess"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" @click="closeOnboardingSuccess">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="loader-container" v-if="isLoadingOnboarding">
              <div class="center-content3">
                <div style="margin-bottom: 250px; font-size: 12px; color: #000">
                  <center>
                    <div class="loader2" style="margin-bottom: 15px"></div>
                  </center>
                  <p v-if="loadingText === 'Creating Merchant Account'">
                    Creating Merchant Account
                  </p>
                  <p v-else-if="loadingText === 'Setting Up Merchant Business'">
                    Setting Up Merchant Business...
                  </p>
                  <p
                    v-else-if="loadingText === 'Finishing Merchant Onboarding'"
                  >
                    Finishing Merchant Onboarding
                  </p>
                  <p v-else>Please wait...</p>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="center-content3">
                <div v-if="OnbaordingError">
                  <div
                    style="margin-bottom: 170px; font-size: 12px; color: #000"
                  >
                    <div>Ops! An Error occurred while creating Business</div>
                    <br />
                    <div
                      v-if="errorOnboardingMessage"
                      class="alert alert-danger"
                      role="alert"
                    >
                      {{ errorOnboardingMessage }} <br />
                      {{ errorOnboarding }}
                    </div>
                  </div>
                  <div class="modal-footer">
                    <div class="previous-button" @click="previousModal7">
                      Back
                    </div>
                  </div>
                </div>
                <div v-else>
                  <img
                    class="custom-icon-size mb-4"
                    src="@/components/img/Sales_Assests/checkmark.svg"
                    alt="Custom Icon"
                  />
                  <div class="write-up2">Successful</div>
                  <div class="subhead-text2">
                    The Business has been onboarded
                  </div>
                  <div class="subhead-text2" style="margin-bottom: 160px">
                    Successfully
                  </div>
                  <!-- <div v-else-if="errorOnboarding">
        <div class="subhead-text2" style="margin-bottom: 40px">Successfully</div>
        <div class="subhead-text2" style="margin-bottom: 50px; overflow-y: auto;">
          However some error occurred during onboarding: <br>
          {{ errorOnboarding }}
        </div>
      </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  </div>

  <!-- Save&Continue Confirmation Modal -->
  <div class="modal-overlay" v-show="showSaveNContinueDialog">
    <Modal
      class="custom-modal custom-modal-width"
      v-show="showSaveNContinueDialog"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-header-text">Save & Continue Later?</div>
            <button
              type="button"
              class="close"
              @click="showSaveNContinueDialog = false"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body modal-text">
            Are you sure you want to Save now and Continue later?
          </div>

          <div class="modal-footer">
            <button class="logout-cancel" @click="cancelSaveAndContinue">
              Cancel
            </button>
            <!-- <button type="button" class="btn btn-secondary" @click="showlogoutDialog = false">Cancel</button> -->
            <button class="logout-button" @click="confirmSaveAndContinue">
              Yes
            </button>
          </div>
        </div>
      </div>
    </Modal>
  </div>

  <!-- Close Modal Confirmation-->
  <div class="modal-overlay" v-show="CloseModalConfirmation">
    <Modal
      class="custom-modal custom-modal-width"
      v-show="CloseModalConfirmation"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-header-text">Are you sure you want to close?</div>
            <!-- <button type="button" class="close" @click="CloseModalConfirmation = false">
            <span aria-hidden="true">&times;</span>
          </button> -->
          </div>

          <div class="modal-body modal-text">
            You have unsaved changes for your onboarding process, are you sure
            you want to discard these changes?
          </div>

          <div class="modal-footer">
            <button class="logout-cancel" @click="cancelSaveAndContinue">
              Cancel
            </button>
            <!-- <button type="button" class="btn btn-secondary" @click="showlogoutDialog = false">Cancel</button> -->
            <button class="logout-button" @click="ClearAllFeilds">
              Discard
            </button>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import axios from "axios";
import debounce from "lodash/debounce";

function getMimeType(fileExtension) {
  const extensionToType = {
    png: "image/png",
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    pdf: "application/pdf",
  };

  const lowerCaseExtension = fileExtension.toLowerCase();
  return extensionToType[lowerCaseExtension] || "";
}

function getMimeTypeFromFileName(fileName) {
  // Extract file extension from the file name
  const fileExtension = fileName.split(".").pop().toLowerCase();

  // Map file extensions to MIME types
  const extensionToType = {
    png: "image/png",
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    pdf: "application/pdf",
    // Add more mappings as needed
  };

  // Look up the MIME type based on the file extension
  return extensionToType[fileExtension] || "";
}

export default {
  props: {
    showOnboardingModal0: {
      type: Boolean,
      required: true,
    },
    onboardButtonClicked: {
      type: Boolean,
      required: true,
    },
    forBankMerchants: {
      type: Boolean,
      required: false,
    },
    rowData: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      isContinue: false,
      errorNINMessage: "",
      errorBVNMessage: "",
      errorVerificationMessage: "",
      errorLocationMessage: "",
      errorCashierMessage: "",
      errorNINInput: "",
      errorRCInput: "",
      errorAcctMessage: "",
      OnbaordingError: false,
      errorOnboardingMessage: "",
      errorOnboarding: "",
      businessType: "",
      businessTypes: [],
      loading: true,
      loadingBVN: true,
      loadingAcct: false,
      isLoadingOnboarding: false,
      loadingText: "Creating Merchant Account",
      VerifiedNIN: true,
      VerifiedBVN: false,
      AccountVerified: false,
      acctNumber: "",
      banks: [],
      acctName: "",
      selectedBank: "",
      selectedBankName: "",
      selectedBankCode: "",
      states: [],
      selectedState: "",
      selectedStateName: "",
      selectedStateLGAs: [],
      selectedStateLGAName: "",
      selectedLGA: "",
      isDropdownOpen: false,
      showOnboardingModal1: true,
      showOnboardingModal2: false,
      showOnboardingModal3: false,
      showOnboardingModal4: false,
      showOnboardingModal5: false,
      showOnboardingModal6: false,
      showOnboardingModal7: false,
      showOnboardingSuccess: false,
      LocationForm: true,
      CashierForm: true,
      firstName: "",
      lastName: "",
      NIN: "",
      BVN: "",
      phoneNumber: "",
      GovID: "",
      IDType: "",
      RegCode: "",
      taxNumber: "",
      uploadedFile: null,
      uploadedUtilityBill: null,
      uploadedTinSlip: null,
      uploadedStatusReport: null,
      uploadedLetterOfIntro: null,
      uploadedCompanyProfile: null,
      uploadedNatureOFBusiness: null,
      uploadedMEMART: null,
      uploadedNDA: null,
      uploadedBoardofRF: null,
      uploadedCAC: null,
      uploadedIndemnity: null,
      showSaveNContinueDialog: false,
      CloseModalConfirmation: false,
      modalNumberToSave: null,
      DoNotShowAgain: false,

      locationList: [],
      locationName: "",
      locationAddress: "",
      state: "",
      lga: "",

      cashierList: [],
      cashierlocation: "",
      CashierFirstName: "",
      CashierLastName: "",
      CashierPhoneNumber: "",
      cashierEmail: "",
      userID: "",
      SE_DNSA: "",
      Flow1: null,
      IDtypeNumber: null,
      InvalidTIN: false,
      errorTINInput: "",
      TransactionMax: "",
      rowDataCheck: [],
      MAX_FILE_SIZE_MB: 1.75,
      fileUploadErrors: {},
    };
  },

  computed: {
    passportPattern() {
      return /^[A-Za-z]\d{8}$/;
    },

    isNINDisabled() {
      return !(this.firstName && this.lastName);
    },
  },

  async mounted() {
    this.userEmail = sessionStorage.getItem("email");
    this.userID = sessionStorage.getItem("userId");
    try {
      await this.fetchUserDetails();
      await this.fetchBanks();
      await this.fetchStates();
      await this.fetchBusinessTypes();
    } catch (error) {
      console.error(error);
      this.$toast.open({
        message: error,
        type: "error",
        duration: 3000,
      });
    }
  },

  watch: {
    rowData: {
      handler(newVal) {
        if (newVal) {
          this.isContinue = true;
          if (this.forBankMerchants) {
            this.checkForBankMerchants();
          } else {
            this.checkForContinueOnboard();
          }
        }
      },
      immediate: true,
      deep: true,
    },

    firstName: {
      handler: debounce(function (newValue) {
        if (newValue && this.lastName && this.NIN.length === 11) {
          this.callAPI();
        } else if (newValue && this.lastName && this.BVN.length === 11) {
          this.callBVNAPI();
        }
      }, 1000),
      immediate: false,
    },
    lastName: {
      handler: debounce(function (newValue) {
        if (newValue && this.firstName && this.NIN.length === 11) {
          this.callAPI();
        }
        if (newValue && this.firstName && this.BVN.length === 11) {
          this.callBVNAPI();
        }
      }, 1000),
      immediate: false,
    },

    // NIN: {
    //   handler: debounce(function(newValue) {
    //     if (newValue.length === 11 && this.firstName && this.lastName) {
    //       this.callAPI();
    //     }
    //   }, 1000),
    //   immediate: false,
    // },

    BVN: {
      handler: debounce(function (newValue) {
        if (newValue.length === 11 && this.firstName && this.lastName) {
          this.callBVNAPI();
        }
      }, 1000),
      immediate: false,
    },

    acctNumber: {
      handler: debounce(function (newValue) {
        if (newValue.length === 10 && this.selectedBankCode) {
          this.callAccountInquiryAPI();
        }
      }, 1000),
      immediate: false,
    },

    selectedBankCode: {
      handler: debounce(function (newValue) {
        if (newValue && this.acctNumber) {
          this.callAccountInquiryAPI();
          this.selectedBankName = this.getBankName(newValue);
        }
      }, 1000),
      immediate: false,
    },
  },

  methods: {
    async handleFileChange(event, fileType) {
      const selectedFile = event.target.files[0];
      if (!selectedFile) return;

      const fileSizeMB = selectedFile.size / (1024 * 1024);
      if (fileSizeMB > this.MAX_FILE_SIZE_MB) {
        this.fileUploadErrors[
          fileType
        ] = `File too large. Max allowed size is ${this.MAX_FILE_SIZE_MB} MB.`;
        return;
      }

      // Clear previous error for this fileType
      this.fileUploadErrors[fileType] = null;

      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result.split(",")[1];
        const fileExtension = selectedFile.name.split(".").pop();
        const mimeType = getMimeType(fileExtension);

        switch (fileType) {
          case "govtId":
            this.uploadedFile = {
              file: selectedFile,
              mimeType,
              base64Content: base64String,
            };
            break;
          case "utilityBill":
            this.uploadedUtilityBill = {
              file: selectedFile,
              mimeType,
              base64Content: base64String,
            };
            break;
          case "tinSlip":
            this.uploadedTinSlip = {
              file: selectedFile,
              mimeType,
              base64Content: base64String,
            };
            break;
          case "MEMART":
            this.uploadedMEMART = {
              file: selectedFile,
              mimeType,
              base64Content: base64String,
            };
            break;
          case "StatusReport":
            this.uploadedStatusReport = {
              file: selectedFile,
              mimeType,
              base64Content: base64String,
            };
            break;
          case "LetterOfIntro":
            this.uploadedLetterOfIntro = {
              file: selectedFile,
              mimeType,
              base64Content: base64String,
            };
            break;
          case "CompanyProfile":
            this.uploadedCompanyProfile = {
              file: selectedFile,
              mimeType,
              base64Content: base64String,
            };
            break;
          case "NatureOFBusiness":
            this.uploadedNatureOFBusiness = {
              file: selectedFile,
              mimeType,
              base64Content: base64String,
            };
            break;
          case "BoardofRF":
            this.uploadedBoardofRF = {
              file: selectedFile,
              mimeType,
              base64Content: base64String,
            };
            break;
          case "NDA":
            this.uploadedNDA = {
              file: selectedFile,
              mimeType,
              base64Content: base64String,
            };
            break;
          case "CACDocument":
            this.uploadedCAC = {
              file: selectedFile,
              mimeType,
              base64Content: base64String,
            };
            break;
          case "indemnity":
            this.uploadedIndemnity = {
              file: selectedFile,
              mimeType,
              base64Content: base64String,
            };
            break;
          default:
            break;
        }
      };
      reader.readAsDataURL(selectedFile);
    },

    async fetchBusinessTypes() {
      try {
        const response = await axios.get(
          "https://app.swwipe.com/api/v1/Public/businessType"
        );
        if (response.status == 200) {
          this.businessTypes = response.data.data.data;
        } else {
          console.error("Error fetching business types");
        }
      } catch (error) {
        console.error("API fetch error:", error);
      }
    },

    async checkForBankMerchants() {
      console.log("Setting for bank merchants");
      const FullName = this.rowData.merchantName.split(" ");

      this.firstName = FullName[0];
      this.lastName = FullName[FullName.length - 1];
      this.acctNumber = this.rowData.accountNumber;
      this.phoneNumber = this.rowData.mobilePhoneNo;
      this.email = this.rowData.email;
      this.selectedBankCode = this.rowData.bankCode;

      this.Flow1 = 1;
      this.$emit("open-modal1");
    },

    async checkForContinueOnboard() {
      if (this.rowData != null) {
        console.log("row data parsed:", this.rowData);
        this.businessName = this.rowData.BusinessName;
        this.email = this.rowData.Email;
        this.businessType = this.rowData.BusinessType;
        this.taxNumber = this.rowData.TIN;
        this.phoneNumber = this.rowData.PhoneNumber;
        this.GovID = this.rowData.GovIDType;
        this.UpdateGovIDNumber();
        this.IDType = this.rowData.IDNumber;

        this.uploadedFile = this.rowData.IDUpload;
        console.log(" Gov ID value is :", this.uploadedFile);
        if (this.uploadedFile.length !== 0) {
          console.log("Gov ID passed:");
          this.uploadedFile = {
            file: { name: this.rowData.NameOfFile_IDUpload || "" },
            mimeType: getMimeTypeFromFileName(
              this.rowData.NameOfFile_IDUpload || ""
            ),
            base64Content: this.rowData.IDUpload,
          };
        }
        this.uploadedUtilityBill = this.rowData.UtilityBill;
        console.log("Utility bill value is :", this.uploadedUtilityBill);
        if (this.uploadedUtilityBill.length !== 0) {
          console.log("Utility bill passed:");
          this.uploadedUtilityBill = {
            file: { name: this.rowData.NameOfFile_UtilityBill || "" },
            mimeType: getMimeTypeFromFileName(
              this.rowData.NameOfFile_UtilityBill || ""
            ),
            base64Content: this.rowData.UtilityBill,
          };
        }

        this.RegCode = this.rowData.RegCode;
        this.uploadedCAC = this.rowData.CAC;
        if (this.uploadedCAC.length !== 0) {
          this.uploadedCAC = {
            file: { name: this.rowData.NameOfFile_CAC || "" },
            mimeType: getMimeTypeFromFileName(
              this.rowData.NameOfFile_CAC || ""
            ),
            base64Content: this.rowData.RegCode,
          };
        }

        this.firstName = this.rowData.FirstName;
        this.lastName = this.rowData.LastName;
        this.NIN = this.rowData.NIN;
        this.BVN = this.rowData.BVN;
        this.acctNumber = this.rowData.AccountNumber;
        this.TransactionMax = this.rowData.TransactionMax;
        this.retrievedBankName = this.rowData.Bank;
        if (this.retrievedBankName.length > 0) {
          this.getBankCode(this.retrievedBankName);
        }
        this.uploadedIndemnity = this.rowData.IndemnityForm;
        if (this.uploadedIndemnity.length !== 0) {
          this.uploadedIndemnity = {
            file: { name: this.rowData.NameOfFile_IndemnityForm || "" },
            mimeType: getMimeTypeFromFileName(
              this.rowData.NameOfFile_IndemnityForm || ""
            ),
            base64Content: this.rowData.IndemnityForm,
          };
        }

        this.locationList = JSON.parse(this.rowData.Locations);
        this.cashierList = JSON.parse(this.rowData.Cashiers);

        const getmodalNumber = this.rowData.ModalNumber;

        if (getmodalNumber == 1) {
          this.openOnboardingModal1();
        } else if (getmodalNumber == 2) {
          this.showModal1 = false;
          this.showOnboardingModal2 = true;
        } else if (getmodalNumber == 3) {
          this.showModal1 = false;
          this.showOnboardingModal3 = true;
        } else if (getmodalNumber == 4) {
          this.showModal1 = false;
          this.showOnboardingModal4 = true;
        } else if (getmodalNumber == 5) {
          this.showModal1 = false;
          this.showOnboardingModal5 = true;
        } else if (getmodalNumber == 6) {
          this.showModal1 = false;
          this.showOnboardingModal6 = true;
        } else if (getmodalNumber == 7) {
          this.showModal1 = false;
          this.showOnboardingModal7 = true;
        }
      }
    },

    getBankCode(name) {
      const selectedBank = this.banks.find((bank) => bank.name === name);
      this.selectedBankCode = selectedBank.code;
    },

    downloadFile(fileType) {
      console.log("Received fileType:", fileType); // Debugging

      const files = {
        IndemnityFORM: {
          url: "https://portal.swwipe.com/Swwipe-Assets/IndemnityForm.pdf",
          name: "IndemnityForm.pdf",
        },
        NatureOfBusiness: {
          url: "https://portal.swwipe.com/Swwipe-Assets/NOB.docx",
          name: "NatureOfBusiness.docx",
        },
        NDA: {
          url: "https://portal.swwipe.com/Swwipe-Assets/NDA.pdf",
          name: "NDA.pdf",
        },
        BOR: {
          url: "https://portal.swwipe.com/Swwipe-Assets/BOR.docx",
          name: "BOR.docx",
        },
      };

      if (!fileType || !files[fileType]) {
        console.error("Invalid file type:", fileType); // Log error
        return;
      }

      const { url, name } = files[fileType];

      const link = document.createElement("a");
      link.href = url;
      link.download = name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    validateTaxNumber(event) {
      // Get the input value
      let inputValue = event.target.value;

      // Remove any non-numeric characters except hyphen
      inputValue = inputValue.replace(/[^\d-]/g, "");

      // Split the input value by hyphen
      const parts = inputValue.split("-");

      // Join the parts back with a single hyphen
      inputValue =
        parts[0] + (parts.length > 1 ? "-" + parts.slice(1).join("") : "");

      // Check if the input value follows the pattern '12345678-9101'
      if (/^\d{0,8}(-\d{0,4})?$/.test(inputValue)) {
        // Update the taxNumber value
        this.taxNumber = inputValue;
        this.InvalidTIN = false;
      } else {
        this.InvalidTIN = true;
        this.errorTINInput = "Invalid TIN format provided ";
        setTimeout(() => {
          this.errorTINInput = false;
        }, 3000);
      }
    },

    onPhoneInput(event) {
      const inputValue = event.target.value;
      const numericValue = inputValue.replace(/\D/g, "");

      this.phoneNumber = numericValue;
    },

    onCashierPhoneInput(event) {
      const inputValue = event.target.value;
      const numericValue = inputValue.replace(/\D/g, "");

      this.CashierPhoneNumber = numericValue;
    },

    onInputAcct(event) {
      const inputValue = event.target.value;
      const numericValue = inputValue.replace(/\D/g, "");

      if (inputValue !== numericValue) {
        this.errorNINInput = "Only numeric characters are allowed here";
        setTimeout(() => {
          this.errorNINInput = false;
        }, 3000);
      }

      this.acctNumber = numericValue;
    },

    onInputBVN(event) {
      const inputValue = event.target.value;
      const numericValue = inputValue.replace(/\D/g, "");

      if (inputValue !== numericValue) {
        this.errorNINInput = "Only numeric characters are allowed here";
        setTimeout(() => {
          this.errorNINInput = false;
        }, 3000);
      }

      this.BVN = numericValue;
    },

    onInputNIN(event) {
      const inputValue = event.target.value;
      const numericValue = inputValue.replace(/\D/g, "");

      if (inputValue !== numericValue) {
        this.errorNINInput = "Only numeric characters are allowed here";
        setTimeout(() => {
          this.errorNINInput = false;
        }, 3000);
      }
      this.NIN = numericValue;
    },

    onAlphanumericInput(event) {
      const inputValue = event.target.value;
      const alphanumericValue = inputValue.replace(/[^a-zA-Z0-9]/g, "");

      if (inputValue !== alphanumericValue) {
        this.errorRCInput = "Only Alphanumeric characters are allowed here";
        setTimeout(() => {
          this.errorRCInput = false;
        }, 3000);
      }

      this.RegCode = alphanumericValue;
    },

    onInput(event) {
      const inputValue = event.target.value;
      const numericValue = inputValue.replace(/\D/g, "");

      if (inputValue !== numericValue) {
        this.errorNINInput = "Only numeric characters are allowed here";
        setTimeout(() => {
          this.errorNINInput = false;
        }, 3000);
      }

      this.IDType = numericValue;
    },

    async startLoader() {
      this.OnbaordingError = false;
      this.errorOnboardingMessage = false;
      this.errorOnboarding = false;
      try {
        this.isLoadingOnboarding = true;

        await new Promise((resolve) => setTimeout(resolve, 2000));

        // Update loading text
        this.loadingText = "Setting Up Merchant Business";

        // Simulate delay for demonstration purposes
        await new Promise((resolve) => setTimeout(resolve, 2000));

        // Update loading text
        this.loadingText = "Finishing Merchant Onboarding";

        // Simulate delay for demonstration purposes
        await new Promise((resolve) => setTimeout(resolve, 2000));
        this.loadingText = "Please wait...";
      } catch (error) {
        console.error(error);
      }
    },

    UpdateGovIDNumber() {
      if (this.GovID == "International Passport") {
        this.IDtypeNumber = 8;
      } else if (this.GovID == "Driver`s licence") {
        this.IDtypeNumber = 6;
      } else if (this.GovID == "NIN Slip") {
        this.IDtypeNumber = 5;
      } else if (this.GovID == "Voter`s Card") {
        this.IDtypeNumber = 7;
      } else {
        this.IDtypeNumber = 4;
      }
    },

    getBankName(code) {
      const selectedBank = this.banks.find((bank) => bank.code === code);
      return selectedBank ? selectedBank.name : "";
    },

    async submitOnboarding() {
      this.startLoader();
      this.openOnboardingSuccess();

      try {
        const documents = [];

        // Add uploaded files to documents array
        if (this.uploadedFile) {
          documents.push({
            filename: this.uploadedFile.file.name,
            mimeType: this.uploadedFile.mimeType,
            base64Content: this.uploadedFile.base64Content,
            documentType: this.IDtypeNumber,
            idNumber: this.IDType,
          });
        }
        if (this.uploadedUtilityBill) {
          documents.push({
            filename: this.uploadedUtilityBill.file.name,
            mimeType: this.uploadedUtilityBill.mimeType,
            base64Content: this.uploadedUtilityBill.base64Content,
            documentType: 3,
            idNumber: this.IDType,
          });
        }
        // if (this.uploadedCAC) {
        //     documents.push({
        //         filename: this.uploadedCAC.file.name,
        //         mimeType: this.uploadedCAC.mimeType,
        //         base64Content: this.uploadedCAC.base64Content,
        //         documentType: 2,
        //         idNumber: this.IDType
        //     });
        // }
        if (this.uploadedIndemnity) {
          documents.push({
            filename: this.uploadedIndemnity.file.name,
            mimeType: this.uploadedIndemnity.mimeType,
            base64Content: this.uploadedIndemnity.base64Content,
            documentType: 9,
            idNumber: this.IDType,
          });
        }

        const locations = this.locationList.map((location) => {
          const cashiers = this.cashierList.filter(
            (cashier) => cashier.location === location.name
          );
          return {
            address: location.address,
            locationName: location.name,
            state: location.stateName,
            lga: location.lgaName,
            activateTippingFeature: false,
            cashiers: cashiers.map((cashier) => ({
              firstname: cashier.firstname,
              lastname: cashier.lastname,
              phoneNumber: cashier.phonenumber,
              email: cashier.email,
            })),
          };
        });

        const payload = {
          salesExecutiveId: parseInt(this.userID),
          firstname: this.firstName,
          lastname: this.lastName,
          email: this.email,
          phoneNumber: this.phoneNumber,
          bvn: this.BVN,
          nin: this.NIN,
          rcNumber: this.RegCode,
          tin: this.taxNumber,
          accountType: 2,
          businesDetails: {
            businessName: this.businessName,
            businessType: this.businessType,
            accountDetail: {
              accountNumber: this.acctNumber,
              accountName: this.acctName,
              bankCode: this.selectedBankCode,
            },
            uploadDocument: {
              govtIssuedIdType: this.GovID,
              idNumber: this.IDType,
              BusinessRegNumber: this.RegCode,
              documents: documents,
            },
            locations: locations,
          },
          cacDocument: {
            filename: this.uploadedCAC.file.name,
            mimeType: this.uploadedCAC.mimeType,
            base64Content: this.uploadedCAC.base64Content,
            documentType: 2,
            idNumber: this.RegCode,
          },
          tinDocument: {
            filename: this.uploadedTinSlip.file.name,
            mimeType: this.uploadedTinSlip.mimeType,
            base64Content: this.uploadedTinSlip.base64Content,
            documentType: 1,
            idNumber: this.taxNumber,
          },
          natureOfBusinessForm: {
            filename: this.uploadedNatureOFBusiness.file.name,
            mimeType: this.uploadedNatureOFBusiness.mimeType,
            base64Content: this.uploadedNatureOFBusiness.base64Content,
            documentType: 10,
          },
          memart: {
            filename: this.uploadedMEMART.file.name,
            mimeType: this.uploadedMEMART.mimeType,
            base64Content: this.uploadedMEMART.base64Content,
            documentType: 11,
          },
          statusReport: {
            filename: this.uploadedStatusReport.file.name,
            mimeType: this.uploadedStatusReport.mimeType,
            base64Content: this.uploadedStatusReport.base64Content,
            documentType: 12,
          },
          companyProfile: {
            filename: this.uploadedCompanyProfile.file.name,
            mimeType: this.uploadedCompanyProfile.mimeType,
            base64Content: this.uploadedCompanyProfile.base64Content,
            documentType: 13,
          },
          letterOfIntroductionOfAuthSignatories: {
            filename: this.uploadedLetterOfIntro.file.name,
            mimeType: this.uploadedLetterOfIntro.mimeType,
            base64Content: this.uploadedLetterOfIntro.base64Content,
            documentType: 14,
          },
          nonDisclosureAgreeementForm: {
            filename: this.uploadedNDA.file.name,
            mimeType: this.uploadedNDA.mimeType,
            base64Content: this.uploadedNDA.base64Content,
            documentType: 16,
          },
          boardOfResolutionForm: {
            filename: this.uploadedBoardofRF.file.name,
            mimeType: this.uploadedBoardofRF.mimeType,
            base64Content: this.uploadedBoardofRF.base64Content,
            documentType: 15,
          },
          proofOfAddress: {
            filename: this.uploadedUtilityBill.file.name,
            mimeType: this.uploadedUtilityBill.mimeType,
            base64Content: this.uploadedUtilityBill.base64Content,
            documentType: 3,
          },
        };
        const response = await axios.post(
          this.$config.CREATEMERCHANT_ENDPOINT,
          payload
        );
        console.log("Payload is:", payload);
        if (response.status == 200 && response.data.statusCode == "00") {
          if (response.data.errors.length !== 0) {
            this.OnbaordingError = true;
            this.errorOnboardingMessage = response.data.errorMessage;
            this.errorOnboarding = response.data.errors;
            this.isLoadingOnboarding = false;
            return;
          }
          console.log("Successful:", response);

          if (this.DoNotShowAgain) {
            this.UpdateDoNoShowAgain();
          }
          this.ClearAllFeilds();
          this.$emit("reload-onboarded");
          this.isLoadingOnboarding = false;
        }
      } catch (error) {
        this.OnbaordingError = true;
        this.errorOnboardingMessage = error.response.data.errorMessage;
        this.errorOnboarding = error.response.data.errors;
        this.isLoadingOnboarding = false;
        console.error(error);
      }
    },

    async fetchStates() {
      try {
        const response = await axios.get(this.$config.GETALLSTATE_ENDPOINT);
        this.states = response.data.data;
      } catch (error) {
        console.error(error);
      }
    },

    getLGAName() {
      const selectedLGA = this.selectedStateLGAs.find(
        (lga) => lga.id === this.selectedLGA
      );
      if (selectedLGA) {
        this.selectedStateLGAName = selectedLGA.name;
      } else {
        this.selectedLGA = [];
      }
    },

    updateLGAs() {
      const selectedState = this.states.find(
        (state) => state.id === this.selectedState
      );
      if (selectedState) {
        this.selectedStateLGAs = selectedState.lga;
        this.selectedStateName = selectedState.name;
      } else {
        this.selectedStateLGAs = [];
      }
    },

    async callAccountInquiryAPI() {
      try {
        this.loadingAcct = true;
        this.errorAcctMessage = false;
        const response = await axios.get(
          `${this.$config.ACCOUNTINQUIRY_ENDPOINT}/${this.acctNumber}/bankCode/${this.selectedBankCode}`
        );

        if (response.status == 200) {
          if (response.data.data.name == "Error getting account name") {
            this.loadingAcct = false;
            this.acctName = "";
            this.AccountVerified = false;
            this.errorAcctMessage = "Invalid Account Number";
            setTimeout(() => {
              this.errorAcctMessage = false;
            }, 4000);
          } else {
            this.loadingAcct = false;
            this.acctName = response.data.data.name;
            this.AccountVerified = true;
          }
        }
      } catch (error) {
        this.loadingAcct = false;
        this.acctName = "";
        this.AccountVerified = false;
        console.error(
          "Request could not be completed, Please try again later.",
          error
        );
        this.errorAcctMessage =
          "Request could not be completed, Please try again later.";
        setTimeout(() => {
          this.errorAcctMessage = false;
        }, 4000);
        console.error(error);
      }
    },

    async fetchBanks() {
      try {
        const response = await axios.get(this.$config.GETBANKCODE_ENDPOINT);
        this.banks = response.data.data;
      } catch (error) {
        console.error("Error fetching banks:", error);
      }
    },

    async callBVNAPI() {
      try {
        this.loadingBVN = true;
        this.errorBVNMessage = false;
        const response = await axios.post(this.$config.VALIDATEBVN_ENDPOINT, {
          firstname: this.firstName,
          lastname: this.lastName,
          bvn: this.BVN,
        });

        if (response.status == 200) {
          this.loadingBVN = false;
          this.VerifiedBVN = true;
        }
      } catch (error) {
        this.loadingBVN = false;
        this.VerifiedBVN = false;
        console.error(
          "BVN Verification failed, please confirm your BVN and try again.",
          error
        );
        this.errorBVNMessage =
          "BVN Verification failed, please confirm your BVN and try again.";
        setTimeout(() => {
          this.errorBVNMessage = false;
        }, 4000);
      }
    },

    async callAPI() {
      try {
        this.loading = true;
        this.errorNINMessage = false;
        const response = await axios.get(
          `${this.$config.VALIDATENIN_ENDPOINT}?nin=${this.NIN}`
        );
        if (response.status == 200) {
          if (response.data.message == "No data found for the nin") {
            this.loading = false;
            this.VerifiedNIN = false;
            this.errorNINMessage = "NIN is Invalid";
            setTimeout(() => {
              this.errorNINMessage = false;
            }, 4000);
          }

          const inputFirstName = this.firstName.toLowerCase();
          const inputLastName = this.lastName.toLowerCase();
          const responseData = response.data;
          const responseFirstName = responseData.data.firstname.toLowerCase();
          const responseLastName = responseData.data.surname.toLowerCase();

          if (
            responseData.message == "Nin is valid." &&
            responseLastName === inputLastName &&
            responseFirstName === inputFirstName
          ) {
            this.loading = false;
            this.VerifiedNIN = true;
          } else if (
            responseData.message == "Nin is valid." &&
            responseLastName !== inputLastName &&
            responseFirstName === inputFirstName
          ) {
            this.loading = false;
            this.VerifiedNIN = false;
            this.errorNINMessage = "Last Name does not Match details on NIN";
            setTimeout(() => {
              this.errorNINMessage = false;
            }, 4000);
          } else if (
            responseData.message == "Nin is valid." &&
            responseLastName === inputLastName &&
            responseFirstName !== inputFirstName
          ) {
            this.loading = false;
            this.VerifiedNIN = false;
            this.errorNINMessage = "First Name does not Match details on NIN";
            setTimeout(() => {
              this.errorNINMessage = false;
            }, 4000);
          } else if (
            responseData.message == "Nin is valid." &&
            responseLastName !== inputLastName &&
            responseFirstName !== inputFirstName
          ) {
            this.loading = false;
            this.VerifiedNIN = false;
            this.errorNINMessage =
              "First Name & Last Name does not Match details on NIN";
            setTimeout(() => {
              this.errorNINMessage = false;
            }, 4000);
          }
        }
      } catch (error) {
        this.loading = false;
        this.VerifiedNIN = false;
        this.errorNINMessage =
          "Service currently unavailable, please try again later";
        setTimeout(() => {
          this.errorNINMessage = false;
        }, 4000);
        console.error("Error fetching user details:", error);
      }
    },

    UpdateDoNoShowAgain() {
      const token = sessionStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      axios
        .put(`${this.$config.UPDATEDONOTSHOW_ENDPOINT}/${this.userID}`, {
          headers: headers,
        })
        .then((response) => {
          if (response.status === 200) {
            console.log("Do not disturb has been updated successfully");
          } else {
            throw new Error("Failed to save data.");
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    },

    async fetchUserDetails() {
      try {
        const response = await axios.get(
          `${this.$config.GETUSERBYEMAIL_ENDPOINT}?email=${this.userEmail}`
        );

        this.SE_DNSA = response.data.SE_DNSA;
        console.log("Value is", this.SE_DNSA);
      } catch (error) {
        console.error("Error fetching user details:", error);
      }
    },

    ClearAllFeilds() {
      this.CloseModalConfirmation = false;
      this.businessType = "";
      this.businessName = "";
      this.email = "";
      this.taxNumber = "";
      this.phoneNumber = "";
      this.GovID = "";
      this.IDType = "";
      this.uploadedFile = null;
      this.RegCode = "";
      this.uploadedUtilityBill = null;
      this.uploadedCAC = null;
      this.firstName = "";
      this.lastName = "";
      this.NIN = "";
      this.BVN = "";
      this.VerifiedNIN = null;
      this.VerifiedBVN = null;
      this.acctNumber = "";
      this.selectedBankCode = "";
      this.acctName = "";
      this.uploadedIndemnity = null;
      this.locationList = [];
      this.cashierList = [];
      this.$emit("close-modal1");
      this.$emit("close-modal3");
      this.isContinue = false;
      this.Flow1 = 0;
    },

    CloseModal(modalNumber) {
      let InputFieldsModal = [];

      if (modalNumber === 1) {
        if (this.businessType) InputFieldsModal.push(this.businessType);
        if (this.businessName) InputFieldsModal.push(this.businessName);
        if (this.email) InputFieldsModal.push(this.email);
        if (this.taxNumber) InputFieldsModal.push(this.taxNumber);
        if (this.phoneNumber) InputFieldsModal.push(this.phoneNumber);
      }
      if (modalNumber === 2) {
        if (this.businessType) InputFieldsModal.push(this.businessType);
        if (this.businessName) InputFieldsModal.push(this.businessName);
        if (this.email) InputFieldsModal.push(this.email);
        if (this.taxNumber) InputFieldsModal.push(this.taxNumber);
        if (this.phoneNumber) InputFieldsModal.push(this.phoneNumber);
        if (this.GovID) InputFieldsModal.push(this.GovID);
        if (this.IDType) InputFieldsModal.push(this.IDType);
        if (this.uploadedFile) InputFieldsModal.push(this.uploadedFile);
        if (this.uploadedUtilityBill)
          InputFieldsModal.push(this.uploadedUtilityBill);
        if (this.uploadedCAC) InputFieldsModal.push(this.uploadedCAC);
      }
      if (modalNumber === 3) {
        if (this.businessType) InputFieldsModal.push(this.businessType);
        if (this.businessName) InputFieldsModal.push(this.businessName);
        if (this.email) InputFieldsModal.push(this.email);
        if (this.taxNumber) InputFieldsModal.push(this.taxNumber);
        if (this.phoneNumber) InputFieldsModal.push(this.phoneNumber);
        if (this.GovID) InputFieldsModal.push(this.GovID);
        if (this.IDType) InputFieldsModal.push(this.IDType);
        if (this.uploadedFile) InputFieldsModal.push(this.uploadedFile);
        if (this.uploadedUtilityBill)
          InputFieldsModal.push(this.uploadedUtilityBill);
        if (this.uploadedCAC) InputFieldsModal.push(this.uploadedCAC);
        if (this.firstName) InputFieldsModal.push(this.firstName);
        if (this.lastName) InputFieldsModal.push(this.lastName);
        if (this.NIN) InputFieldsModal.push(this.NIN);
        if (this.BVN) InputFieldsModal.push(this.BVN);
      }
      if (modalNumber === 4) {
        if (this.businessType) InputFieldsModal.push(this.businessType);
        if (this.businessName) InputFieldsModal.push(this.businessName);
        if (this.email) InputFieldsModal.push(this.email);
        if (this.taxNumber) InputFieldsModal.push(this.taxNumber);
        if (this.phoneNumber) InputFieldsModal.push(this.phoneNumber);
        if (this.GovID) InputFieldsModal.push(this.GovID);
        if (this.IDType) InputFieldsModal.push(this.IDType);
        if (this.uploadedFile) InputFieldsModal.push(this.uploadedFile);
        if (this.uploadedUtilityBill)
          InputFieldsModal.push(this.uploadedUtilityBill);
        if (this.uploadedCAC) InputFieldsModal.push(this.uploadedCAC);
        if (this.firstName) InputFieldsModal.push(this.firstName);
        if (this.lastName) InputFieldsModal.push(this.lastName);
        if (this.NIN) InputFieldsModal.push(this.NIN);
        if (this.BVN) InputFieldsModal.push(this.BVN);
        if (this.acctNumber) InputFieldsModal.push(this.acctNumber);
        if (this.bank) InputFieldsModal.push(this.bank);
        if (this.acctName) InputFieldsModal.push(this.acctName);
        if (this.uploadedIndemnity)
          InputFieldsModal.push(this.uploadedIndemnity);
      }
      if (modalNumber === 5) {
        if (this.businessType) InputFieldsModal.push(this.businessType);
        if (this.businessName) InputFieldsModal.push(this.businessName);
        if (this.email) InputFieldsModal.push(this.email);
        if (this.taxNumber) InputFieldsModal.push(this.taxNumber);
        if (this.phoneNumber) InputFieldsModal.push(this.phoneNumber);
        if (this.GovID) InputFieldsModal.push(this.GovID);
        if (this.IDType) InputFieldsModal.push(this.IDType);
        if (this.uploadedFile) InputFieldsModal.push(this.uploadedFile);
        if (this.uploadedUtilityBill)
          InputFieldsModal.push(this.uploadedUtilityBill);
        if (this.uploadedCAC) InputFieldsModal.push(this.uploadedCAC);
        if (this.firstName) InputFieldsModal.push(this.firstName);
        if (this.lastName) InputFieldsModal.push(this.lastName);
        if (this.NIN) InputFieldsModal.push(this.NIN);
        if (this.BVN) InputFieldsModal.push(this.BVN);
        if (this.acctNumber) InputFieldsModal.push(this.acctNumber);
        if (this.bank) InputFieldsModal.push(this.bank);
        if (this.acctName) InputFieldsModal.push(this.acctName);
        if (this.uploadedIndemnity)
          InputFieldsModal.push(this.uploadedIndemnity);
        if (this.locationList) InputFieldsModal.push(this.locationList);
      }
      if (modalNumber === 6) {
        if (this.businessType) InputFieldsModal.push(this.businessType);
        if (this.businessName) InputFieldsModal.push(this.businessName);
        if (this.email) InputFieldsModal.push(this.email);
        if (this.taxNumber) InputFieldsModal.push(this.taxNumber);
        if (this.phoneNumber) InputFieldsModal.push(this.phoneNumber);
        if (this.GovID) InputFieldsModal.push(this.GovID);
        if (this.IDType) InputFieldsModal.push(this.IDType);
        if (this.uploadedFile) InputFieldsModal.push(this.uploadedFile);
        if (this.uploadedUtilityBill)
          InputFieldsModal.push(this.uploadedUtilityBill);
        if (this.uploadedCAC) InputFieldsModal.push(this.uploadedCAC);
        if (this.firstName) InputFieldsModal.push(this.firstName);
        if (this.lastName) InputFieldsModal.push(this.lastName);
        if (this.NIN) InputFieldsModal.push(this.NIN);
        if (this.BVN) InputFieldsModal.push(this.BVN);
        if (this.acctNumber) InputFieldsModal.push(this.acctNumber);
        if (this.bank) InputFieldsModal.push(this.bank);
        if (this.acctName) InputFieldsModal.push(this.acctName);
        if (this.uploadedIndemnity)
          InputFieldsModal.push(this.uploadedIndemnity);
        if (this.locationList) InputFieldsModal.push(this.locationList);
        if (this.cashierList) InputFieldsModal.push(this.cashierList);
      }

      console.log("Input feilds", InputFieldsModal);

      if (InputFieldsModal.length <= 0) {
        if (modalNumber === 1) {
          this.closeOnboardingModal1();
        } else if (modalNumber === 2) {
          this.closeOnboardingModal2();
        } else if (modalNumber === 3) {
          this.closeOnboardingModal3();
        } else if (modalNumber === 4) {
          this.closeOnboardingModal4();
        } else if (modalNumber === 5) {
          this.closeOnboardingModal5();
        } else if (modalNumber === 6) {
          this.closeOnboardingModal6();
        } else if (modalNumber === 7) {
          this.closeOnboardingModal7();
        }
      } else if (InputFieldsModal.length > 0) {
        if (modalNumber === 1) {
          this.closeOnboardingModal1();
          this.CloseModalConfirmation = true;
        } else if (modalNumber === 2) {
          this.closeOnboardingModal2();
          this.CloseModalConfirmation = true;
        } else if (modalNumber === 3) {
          this.closeOnboardingModal3();
          this.CloseModalConfirmation = true;
        } else if (modalNumber === 4) {
          this.closeOnboardingModal4();
          this.CloseModalConfirmation = true;
        } else if (modalNumber === 5) {
          this.closeOnboardingModal5();
          this.CloseModalConfirmation = true;
        } else if (modalNumber === 6) {
          this.closeOnboardingModal6();
          this.CloseModalConfirmation = true;
        } else if (modalNumber === 7) {
          this.closeOnboardingModal7();
          this.CloseModalConfirmation = true;
        }
        this.modalNumberToSave = modalNumber;
      }
    },

    saveData(modalNumber) {
      // Add Authorization header
      const token = sessionStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };

      const payload = {
        UserID: this.userID,
        BusinessType: this.businessType || "",
        BusinessName: this.businessName || "",
        Email: this.email || "",
        TIN: this.taxNumber || "",
        PhoneNumber: this.phoneNumber || "",
        GovIDType: this.GovID || "",
        IDNumber: this.IDType || "",
        RegCode: this.RegCode || "",
        FirstName: this.firstName || "",
        LastName: this.lastName || "",
        TransactionMax: this.TransactionMax || "",
        NIN: this.NIN || "",
        BVN: this.BVN || "",
        AccountNumber: this.acctNumber || "",
        Bank: this.selectedBankName || "",
        AccountName: this.acctName || "",
        Locations: JSON.stringify(this.locationList || []),
        Cashiers: JSON.stringify(this.cashierList || []),
        IDUpload: this.uploadedFile
          ? this.uploadedFile.base64Content || ""
          : "",
        UtilityBill: this.uploadedUtilityBill
          ? this.uploadedUtilityBill.base64Content || ""
          : "",
        CAC: this.uploadedCAC ? this.uploadedCAC.base64Content || "" : "",
        IndemnityForm: this.uploadedIndemnity
          ? this.uploadedIndemnity.base64Content || ""
          : "",
        NameOfFile_IDUpload: this.uploadedFile
          ? this.uploadedFile.file.name || ""
          : "",
        NameOfFile_UtilityBill: this.uploadedUtilityBill
          ? this.uploadedUtilityBill.file.name || ""
          : "",
        NameOfFile_CAC: this.uploadedCAC
          ? this.uploadedCAC.file.name || ""
          : "",
        NameOfFile_IndemnityForm: this.uploadedIndemnity
          ? this.uploadedIndemnity.file.name || ""
          : "",
        ModalNumber: modalNumber,
      };

      let endpoint = null;

      if (!this.isContinue) {
        endpoint = this.$config.SAVEANDCONTINUE_ENDPOINT;
      } else {
        endpoint = `${this.$config.UPDATECONTINUEONBOARD_ENDPOINT}/${this.rowData.ID}`;
      }

      // Send API request to save data
      axios
        .post(endpoint, payload, { headers: headers })
        .then((response) => {
          if (response.status === 200) {
            this.ClearAllFeilds();
            this.$emit("reload-pending");
            this.$emit("close-modal");
            this.isContinue = false;
            this.Flow1 = 0;
            if (this.DoNotShowAgain) {
              this.UpdateDoNoShowAgain();
            }
            this.$toast.open({
              message: "Onboarding Details has been saved successfully",
              type: "success",
              duration: 3000,
            });
          } else {
            throw new Error("Failed to save data."); // Handle error response
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    },

    editModal1() {
      this.showOnboardingModal7 = false;
      this.Flow1 = 1;
      this.showOnboardingModal1 = true;
    },
    editModal2() {
      this.showOnboardingModal7 = false;
      this.showOnboardingModal2 = true;
    },
    editModal3() {
      this.showOnboardingModal7 = false;
      this.showOnboardingModal3 = true;
    },
    editModal4() {
      this.showOnboardingModal7 = false;
      this.showOnboardingModal4 = true;
    },
    editModal5() {
      this.showOnboardingModal7 = false;
      this.showOnboardingModal5 = true;
    },
    editModal6() {
      this.showOnboardingModal7 = false;
      this.showOnboardingModal6 = true;
    },

    saveAndContinue(modalNumber) {
      let requiredFields = [];
      if (modalNumber === 1) {
        requiredFields = ["businessName", "email"];
      }

      for (const field of requiredFields) {
        if (!this[field]) {
          alert(
            `${field.charAt(0).toUpperCase() + field.slice(1)} is required.`
          );
          return;
        }
      }

      // Show the confirmation dialog
      this.showSaveNContinueDialog = true;
      if (modalNumber === 1) {
        this.closeOnboardingModal1();
      } else if (modalNumber === 2) {
        this.closeOnboardingModal2();
      } else if (modalNumber === 3) {
        this.closeOnboardingModal3();
      } else if (modalNumber === 4) {
        this.closeOnboardingModal4();
      } else if (modalNumber === 5) {
        this.closeOnboardingModal5();
      } else if (modalNumber === 6) {
        this.closeOnboardingModal6();
      } else if (modalNumber === 7) {
        this.closeOnboardingModal7();
      }
      this.modalNumberToSave = modalNumber;
    },

    confirmSaveAndContinue() {
      this.showSaveNContinueDialog = false;

      this.saveData(this.modalNumberToSave);
    },

    cancelSaveAndContinue() {
      this.showSaveNContinueDialog = false;

      if (this.modalNumberToSave === 1) {
        if (this.SE_DNSA != 1) {
          this.Flow1 = 1;
        }

        this.$emit("open-modal1");
      } else if (this.modalNumberToSave === 2) {
        this.showOnboardingModal2 = true;
      } else if (this.modalNumberToSave === 3) {
        this.showOnboardingModal3 = true;
      } else if (this.modalNumberToSave === 4) {
        this.showOnboardingModal4 = true;
      } else if (this.modalNumberToSave === 5) {
        this.showOnboardingModal5 = true;
      } else if (this.modalNumberToSave === 6) {
        this.showOnboardingModal6 = true;
      } else if (this.modalNumberToSave === 7) {
        this.showOnboardingModal7 = true;
      }
    },

    openOnboardingSuccess() {
      this.showOnboardingModal7 = false;
      this.showOnboardingSuccess = true;
    },

    closeOnboardingSuccess() {
      this.showOnboardingSuccess = false;
    },

    previousModal0() {
      this.$emit("close-modal1");
      this.isContinue = false;
      this.Flow1 = 0;
      this.$emit("open-modal");
    },
    previousModal1() {
      this.showOnboardingModal2 = false;
      if (this.SE_DNSA != 1) {
        this.Flow1 = 1;
      }

      this.$emit("open-modal1");
    },
    previousModal2() {
      this.showOnboardingModal3 = false;
      this.showOnboardingModal2 = true;
    },
    previousModal3() {
      this.showOnboardingModal4 = false;
      this.showOnboardingModal3 = true;
    },
    previousModal4() {
      this.showOnboardingModal5 = false;
      this.showOnboardingModal4 = true;
    },
    previousModal5() {
      this.showOnboardingModal6 = false;
      this.showOnboardingModal5 = true;
    },
    previousModal6() {
      this.showOnboardingModal7 = false;
      this.showOnboardingModal6 = true;
    },
    previousModal7() {
      this.showOnboardingSuccess = false;
      this.showOnboardingModal7 = true;
    },

    openOnboardingModal1() {
      this.$emit("close-modal");
      // this.SE_DNSA = 1;
      this.Flow1 = 1;
      this.$emit("open-modal1");
    },

    closeOnboardingModal1() {
      this.Flow1 = 0;
      this.$emit("close-modal1");
    },

    closeOnboardingModalX() {
      this.$emit("close-modal1");
    },
    openOnboardingModal7() {
      this.showOnboardingModal6 = false;
      this.showOnboardingModal7 = true;
    },
    closeOnboardingModal7() {
      this.showOnboardingModal7 = false;
    },
    editCashier(index) {
      this.CashierForm = true;
      const cashier = this.cashierList[index];
      this.cashierlocation = cashier.location;
      this.CashierFirstName = cashier.firstname;
      this.CashierLastName = cashier.lastname;
      this.CashierPhoneNumber = cashier.phonenumber;
      this.cashierEmail = cashier.email;
      this.cashierList.splice(index, 1);
    },

    addCashier(event) {
      event.preventDefault();
      const form = event.target;

      const cashierlocationInput = document.getElementById("cashierlocation");
      const CashierFirstNameInput = document.getElementById("CashierFirstName");
      const CashierLastNameInput = document.getElementById("CashierLastName");
      const cashierEmailInput = document.getElementById("cashierEmail");

      if (
        !cashierlocationInput ||
        !CashierFirstNameInput ||
        !CashierLastNameInput ||
        !cashierEmailInput
      ) {
        cashierlocationInput.setCustomValidity("All fields are required");
        return;
      }

      if (cashierlocationInput.value === "") {
        cashierlocationInput.setCustomValidity("Location is required!");
        form.reportValidity();
        return;
      }

      if (CashierFirstNameInput.value === "") {
        CashierFirstNameInput.setCustomValidity(
          "Cashier First Name is required!"
        );
        form.reportValidity();
        return;
      }

      if (CashierLastNameInput.value === "") {
        CashierLastNameInput.setCustomValidity(
          "Cashier Last name is required!"
        );
        form.reportValidity();
        return;
      }

      if (cashierEmailInput.value === "") {
        cashierEmailInput.setCustomValidity("Cashier Email is required!");
        form.reportValidity();
        return;
      }

      cashierlocationInput.setCustomValidity("");
      CashierFirstNameInput.setCustomValidity("");
      CashierLastNameInput.setCustomValidity("");
      cashierEmailInput.setCustomValidity("");

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      if (
        this.cashierlocation &&
        this.CashierFirstName &&
        this.CashierLastName &&
        this.CashierPhoneNumber &&
        this.cashierEmail
      ) {
        this.CashierForm = false;
        this.cashierList.push({
          location: this.cashierlocation,
          firstname: this.CashierFirstName,
          lastname: this.CashierLastName,
          phonenumber: this.CashierPhoneNumber,
          email: this.cashierEmail,
        });

        // Clear the form fields
        this.cashierlocation = "";
        this.CashierFirstName = "";
        this.CashierLastName = "";
        this.CashierPhoneNumber = "";
        this.cashierEmail = "";
      }
    },
    openOnboardingModal6() {
      if (this.locationList.length <= 0) {
        this.errorLocationMessage = "At least one location is required";
        setTimeout(() => {
          this.errorLocationMessage = false;
        }, 4000);
      } else {
        this.showOnboardingModal5 = false;
        this.showOnboardingModal6 = true;
      }
    },
    closeOnboardingModal6() {
      this.showOnboardingModal6 = false;
    },

    editLocation(index) {
      this.LocationForm = true;
      const location = this.locationList[index];
      this.locationName = location.name;
      this.locationAddress = location.address;
      this.selectedState = location.state;
      this.selectedLGA = location.lga;
      this.locationList.splice(index, 1);
    },

    addLocation(event) {
      event.preventDefault();
      const form = event.target;

      const locationNameInput = document.getElementById("locationName");
      const locationAddressInput = document.getElementById("locationAddress");
      const stateInput = document.getElementById("state");
      const lgaInput = document.getElementById("lga");

      if (
        !locationNameInput ||
        !locationAddressInput ||
        !stateInput ||
        !lgaInput
      ) {
        locationNameInput.setCustomValidity("All fields are required");
        return;
      }

      if (locationNameInput.value === "") {
        locationNameInput.setCustomValidity("Location Name is required!");
        form.reportValidity();
        return;
      }

      if (locationAddressInput.value === "") {
        locationAddressInput.setCustomValidity("Address is required!");
        form.reportValidity();
        return;
      }

      if (stateInput.value === "") {
        stateInput.setCustomValidity("State is required!");
        form.reportValidity();
        return;
      }

      if (lgaInput.value === "") {
        lgaInput.setCustomValidity("LGA is required!");
        form.reportValidity();
        return;
      }

      locationNameInput.setCustomValidity("");
      locationAddressInput.setCustomValidity("");
      stateInput.setCustomValidity("");
      lgaInput.setCustomValidity("");

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      if (
        this.locationName &&
        this.locationAddress &&
        this.selectedState &&
        this.selectedLGA
      ) {
        this.LocationForm = false;
        this.locationList.push({
          name: this.locationName,
          address: this.locationAddress,
          state: this.selectedState,
          lga: this.selectedLGA,
          stateName: this.selectedStateName,
          lgaName: this.selectedStateLGAName,
        });

        // Clear the form fields
        this.locationName = "";
        this.locationAddress = "";
        this.selectedState = "";
        this.selectedLGA = "";
      }
    },

    openOnboardingModal5() {
      if (this.AccountVerified) {
        this.showOnboardingModal4 = false;
        this.showOnboardingModal5 = true;
      } else {
        this.errorAcctMessage = "You must Verify your account to continue";
        setTimeout(() => {
          this.errorAcctMessage = false;
        }, 4000);
      }
    },

    closeOnboardingModal5() {
      this.showOnboardingModal5 = false;
    },

    removeFileIndemnity() {
      this.uploadedIndemnity = null;
      const fileInput = this.$refs.indemnity;
      if (fileInput) {
        fileInput.value = "";
      }
    },

    openOnboardingModal4(event) {
      event.preventDefault();
      const form = event.target;

      const firstNameInput = document.getElementById("firstName");
      const lastNameInput = document.getElementById("lastName");
      const NINInput = document.getElementById("NIN");
      const BVNInput = document.getElementById("BVN");
      // const phoneNumberInput = document.getElementById('phoneNumber');

      if (!firstNameInput || !lastNameInput || !NINInput || !BVNInput) {
        firstNameInput.setCustomValidity("All fields are required");
        return;
      }

      if (firstNameInput.value === "") {
        firstNameInput.setCustomValidity("First Name is required!");
        form.reportValidity();
        return;
      }

      if (lastNameInput.value === "") {
        lastNameInput.setCustomValidity("Last Name type is required!");
        form.reportValidity();
        return;
      }

      if (NINInput.value === "") {
        NINInput.setCustomValidity("NIN is required!");
        form.reportValidity();
        return;
      }

      if (BVNInput.value === "") {
        BVNInput.setCustomValidity("BVN is required!");
        form.reportValidity();
        return;
      }

      // if (phoneNumberInput.value === "") {
      //   phoneNumberInput.setCustomValidity("Phone Number is required!");
      //   form.reportValidity();
      //   return;
      // }

      firstNameInput.setCustomValidity("");
      lastNameInput.setCustomValidity("");
      NINInput.setCustomValidity("");
      BVNInput.setCustomValidity("");
      // phoneNumberInput.setCustomValidity("");

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      if (this.VerifiedBVN) {
        this.showOnboardingModal3 = false;
        this.showOnboardingModal4 = true;
        this.fetchBanks();
      } else {
        this.errorVerificationMessage = "BVN must be verified to continue.";
        setTimeout(() => {
          this.errorVerificationMessage = false;
        }, 4000);
      }
    },

    closeOnboardingModal4() {
      this.showOnboardingModal4 = false;
    },

    openOnboardingModal3(event) {
      event.preventDefault();
      const form = event.target;

      const GovIDInput = document.getElementById("GovID");
      const IDTypeInput = document.getElementById("IDType");
      const uploadedFileInput = this.uploadedFile;
      const uploadedUtilityBillInput = this.uploadedUtilityBill;
      const uploadedTinSlipInput = this.uploadedTinSlip;
      const uploadedStatusReportInput = this.uploadedStatusReport;
      const uploadedLetterofIntroInput = this.uploadedLetterOfIntro;
      const uploadedCompanyProfileInput = this.uploadedCompanyProfile;
      const uploadedNatureOFBusinessInput = this.uploadedNatureOFBusiness;
      const uploadedBoardofRFInput = this.uploadedBoardofRF;
      const uploadedNDAInput = this.uploadedNDA;
      const RegCodeInput = document.getElementById("RegCode");
      const uploadedCACInput = this.uploadedCAC;

      if (
        !GovIDInput ||
        !IDTypeInput ||
        !uploadedFileInput ||
        !uploadedUtilityBillInput ||
        !RegCodeInput ||
        !uploadedCACInput ||
        !uploadedTinSlipInput ||
        !uploadedStatusReportInput ||
        !uploadedLetterofIntroInput ||
        !uploadedCompanyProfileInput ||
        !uploadedNatureOFBusinessInput ||
        !uploadedBoardofRFInput ||
        !uploadedNDAInput
      ) {
        GovIDInput.setCustomValidity("All fields are required");
        return;
      }

      if (GovIDInput.value === "") {
        GovIDInput.setCustomValidity("ID Type is required!");
        form.reportValidity();
        return;
      }

      if (IDTypeInput.value === "") {
        IDTypeInput.setCustomValidity("ID Number is required!");
        form.reportValidity();
        return;
      }

      if (uploadedFileInput.value === "") {
        uploadedFileInput.setCustomValidity("ID Upload is required!");
        form.reportValidity();
        return;
      }

      if (uploadedUtilityBillInput.value === "") {
        uploadedUtilityBillInput.setCustomValidity("Utility Bill is required!");
        form.reportValidity();
        return;
      }

      if (RegCodeInput.value === "") {
        RegCodeInput.setCustomValidity("Registration Number is required!");
        form.reportValidity();
        return;
      }

      if (uploadedCACInput.value === "") {
        uploadedCACInput.setCustomValidity("CAC upload is required!");
        form.reportValidity();
        return;
      }

      GovIDInput.setCustomValidity("");
      IDTypeInput.setCustomValidity("");
      RegCodeInput.setCustomValidity("");

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }
      this.showOnboardingModal2 = false;
      this.showOnboardingModal3 = true;
    },

    closeOnboardingModal3() {
      this.showOnboardingModal3 = false;
      // Implement logic to close the modal and maybe cancel the onboarding process
    },

    removeFileCAC() {
      this.uploadedCAC = null;
      const fileInput = this.$refs.CACDocument;
      if (fileInput) {
        fileInput.value = "";
      }
    },
    removeFile() {
      this.uploadedFile = null;
      const fileInput = this.$refs.fileInput;
      if (fileInput) {
        fileInput.value = "";
      }
    },

    removeFileUtility() {
      this.uploadedUtilityBill = null;
      // Clear the file input if needed
      const fileInput = this.$refs.utilitybill;
      if (fileInput) {
        fileInput.value = "";
      }
    },

    removeFileTinSlip() {
      this.uploadedTinSlip = null;
      // Clear the file input if needed
      const fileInput = this.$refs.TinSlip;
      if (fileInput) {
        fileInput.value = "";
      }
    },

    removeFileMEMART() {
      this.uploadedMEMART = null;
      // Clear the file input if needed
      const fileInput = this.$refs.MEMART;
      if (fileInput) {
        fileInput.value = "";
      }
    },

    removeFileStatusReport() {
      this.uploadedStatusReport = null;
      // Clear the file input if needed
      const fileInput = this.$refs.StatusReport;
      if (fileInput) {
        fileInput.value = "";
      }
    },

    removeFileLetterOfIntro() {
      this.uploadedLetterOfIntro = null;
      // Clear the file input if needed
      const fileInput = this.$refs.LetterOfIntro;
      if (fileInput) {
        fileInput.value = "";
      }
    },

    removeFileCompanyProfile() {
      this.uploadedCompanyProfile = null;
      // Clear the file input if needed
      const fileInput = this.$refs.CompanyProfile;
      if (fileInput) {
        fileInput.value = "";
      }
    },

    removeFileNatureOFBusiness() {
      this.uploadedNatureOFBusiness = null;
      // Clear the file input if needed
      const fileInput = this.$refs.NatureOFBusiness;
      if (fileInput) {
        fileInput.value = "";
      }
    },

    removeFileBoardofRF() {
      this.uploadedBoardofRF = null;
      // Clear the file input if needed
      const fileInput = this.$refs.BoardofRF;
      if (fileInput) {
        fileInput.value = "";
      }
    },

    removeFileNDA() {
      this.uploadedNDA = null;
      // Clear the file input if needed
      const fileInput = this.$refs.NDA;
      if (fileInput) {
        fileInput.value = "";
      }
    },

    closeOnboardingModal0() {
      this.$emit("close-modal");
    },
    openOnboardingModal2(event) {
      event.preventDefault();
      const form = event.target;

      const BusinessTypeInput = document.getElementById("type");
      const BusinessNameInput = document.getElementById("businessName");
      const EmailInput = document.getElementById("email");
      const TINInput = document.getElementById("taxNumber");
      const phoneNumberInput = document.getElementById("phoneNumber");

      if (
        !EmailInput ||
        !BusinessTypeInput ||
        !BusinessNameInput ||
        !TINInput ||
        !phoneNumberInput
      ) {
        EmailInput.setCustomValidity("All fields are required");
        return;
      }

      if (EmailInput.value === "") {
        EmailInput.setCustomValidity("Email is required!");
        form.reportValidity();
        return;
      }

      if (BusinessTypeInput.value === "") {
        BusinessTypeInput.setCustomValidity("Business type is required!");
        form.reportValidity();
        return;
      }

      if (BusinessNameInput.value === "") {
        BusinessNameInput.setCustomValidity("Busines Name is required!");
        form.reportValidity();
        return;
      }

      if (TINInput.value === "") {
        TINInput.setCustomValidity("Tax Number is required!");
        form.reportValidity();
        return;
      }

      EmailInput.setCustomValidity("");
      BusinessTypeInput.setCustomValidity("");
      BusinessNameInput.setCustomValidity("");
      TINInput.setCustomValidity("");
      phoneNumberInput.setCustomValidity("");

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      if (this.InvalidTIN || this.taxNumber.length < 13) {
        this.errorTINInput = "Please provide a valid TIN to continue";
        setTimeout(() => {
          this.errorTINInput = false;
        }, 3000);
      } else {
        this.$emit("close-modal1");
        this.Flow1 = 0;
        this.showOnboardingModal2 = true;
      }
    },

    closeOnboardingModal2() {
      this.showOnboardingModal2 = false;
    },

    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
      const selectElement = this.$refs.dropdown2;
      console.log("Ref:", selectElement);

      const clickEvent = new Event("click");
      selectElement.dispatchEvent(clickEvent);

      selectElement.addEventListener("click", function () {
        console.log("mouseDown Event Dispatched");
      });
    },
  },
};
</script>

<style>
.docReq {
  display: flex;
  justify-content: space-between;
  white-space: nowrap;
}

.loader2 {
  height: 4px;
  width: 130px;
  --c: no-repeat linear-gradient(#6f48ff 0 0);
  background: var(--c), var(--c), #d7b8fc;
  background-size: 60% 100%;
  animation: l16 3s infinite;
}
@keyframes l16 {
  0% {
    background-position: -150% 0, -150% 0;
  }
  66% {
    background-position: 250% 0, -150% 0;
  }
  100% {
    background-position: 250% 0, 250% 0;
  }
}

.Save-button2 {
  background-color: #fff;
  color: #000;
  border: none;
  padding: 10px 0px;
  font-weight: bold;
  font-size: 13px;
  border-radius: 3px;
  text-align: center;
  margin-right: 50px;
  cursor: pointer;
  width: 150px;
  height: 40px;
}

.Save-button2:hover {
  background-color: #f1f3f9;
}

.Save-button1 {
  background-color: #fff;
  color: #000;
  border: none;
  padding: 10px 0px;
  font-weight: bold;
  font-size: 13px;
  border-radius: 3px;
  text-align: center;
  margin-right: 155px;
  cursor: pointer;
  width: 150px;
  height: 40px;
}

.Save-button1:hover {
  background-color: #f1f3f9;
}

.preview-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.edit-icon-container {
  display: flex;
  align-items: center;
}

.edit-text {
  color: #6f48ff;
  font-weight: bold;
  cursor: pointer;
  margin-right: 10px;
}

.preview-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.label {
  width: 40%; /* Adjust as needed */
  text-align: left;
  color: #8a98ad;
}

.value {
  width: 60%; /* Adjust as needed */
  text-align: right;
  font-weight: bold;
}

.verification-container {
  position: relative;
}

.verification-status {
  position: absolute;
  top: 50%;
  right: 8px; /* Adjust the distance from the right edge of the input */
  transform: translateY(-50%);
  display: flex;
  align-items: center;
}

.checkmark-icon {
  width: 16px; /* Adjust the size as needed */
  height: auto;
  margin-right: 5px; /* Adjust the margin as needed */
}

.verified-text {
  color: #44ac21; /* Green color */
  font-size: 12px; /* Adjust the font size as needed */
  font-weight: bold;
}

.preview-section-text {
  font-size: 13px;
  color: #000;
  font-weight: bold;
  margin-bottom: 30px;
}

.onboardNext-button {
  background-color: #6f48ff;
  color: #fff;
  border: none;
  padding: 10px 20px;
  font-size: 13px;
  border-radius: 3px;
  cursor: pointer;
  font-weight: bold;
  text-align: center;
  width: 100px;
  height: 40px;
}
.previous-button {
  background-color: #f1f3f9;
  color: #000;
  border: none;
  padding: 10px 20px;
  font-size: 13px;
  border-radius: 3px;
  cursor: pointer;
  font-weight: bold;
  text-align: center;
  width: 100px;
  height: 40px;
}

.Save-button {
  background-color: #fff;
  color: #000;
  border: none;
  padding: 10px 0px;
  font-weight: bold;
  font-size: 13px;
  border-radius: 3px;
  text-align: center;
  margin-right: 50px;
  cursor: pointer;
  width: 150px;
  height: 40px;
}

.Save-button:hover {
  background-color: #f1f3f9;
}

.proceed-button {
  background-color: #6f48ff;
  color: #fff;
  border: none;
  padding: 10px 20px;
  font-size: 14px;
  border-radius: 3px;
  cursor: pointer;
  font-weight: bold;
  text-align: center;
  width: 100px;
  height: 40px;
}

.modal-body-requirements {
  max-height: 330px;
  overflow-y: auto;
}

.modal-body-requirements::-webkit-scrollbar {
  width: 6px; /* Set the width of the scrollbar */
}

.modal-body-requirements::-webkit-scrollbar-thumb {
  background-color: #c6c5cb; /* Set the color of the scrollbar thumb */
  border-radius: 3px; /* Optional: Add rounded corners to the thumb */
}

.tip-button-yes {
  background-color: #6f48ff;
  color: #fff;
  border: none;
  padding: 10px 20px;
  font-size: 14px;
  border-radius: 3px;
  font-weight: bold;
  cursor: pointer;
  margin-top: 20px;
  margin-bottom: 100px;
  width: 140px;
  height: 40px;
}

.tip-button-no {
  background-color: #f1f3f9;
  color: #000;
  border: none;
  padding: 10px 20px;
  font-size: 14px;
  border-radius: 3px;
  font-weight: bold;
  cursor: pointer;
  margin-top: 20px;
  width: 80px;
  height: 40px;
}
.write-up2 {
  font-size: 17px;
  color: #000;
  font-weight: bold;
}

.center-content3 {
  text-align: center;
  margin-top: 140px;
}

.modal-body11 {
  max-height: 250px;
  overflow-y: auto;
}

.modal-body11::-webkit-scrollbar {
  width: 6px; /* Set the width of the scrollbar */
}

.modal-body11::-webkit-scrollbar-thumb {
  background-color: #c6c5cb; /* Set the color of the scrollbar thumb */
  border-radius: 3px; /* Optional: Add rounded corners to the thumb */
}

.modal-body10 {
  max-height: 300px;
  overflow-y: auto;
}

.modal-body10::-webkit-scrollbar {
  width: 6px; /* Set the width of the scrollbar */
}

.modal-body10::-webkit-scrollbar-thumb {
  background-color: #c6c5cb; /* Set the color of the scrollbar thumb */
  border-radius: 3px; /* Optional: Add rounded corners to the thumb */
}
.location-modal {
  max-height: 100px;
  overflow-y: auto;
}

.location-modal::-webkit-scrollbar {
  width: 6px; /* Set the width of the scrollbar */
}

.location-modal::-webkit-scrollbar-thumb {
  background-color: #c6c5cb; /* Set the color of the scrollbar thumb */
  border-radius: 3px; /* Optional: Add rounded corners to the thumb */
}

.location-card {
  border-radius: 3px;
  margin-bottom: 10px;
  padding: 10px;
  display: flex;
  align-items: center;
  margin-left: 20px;
  margin-right: 20px;
  background-color: #f1f3f9;
  height: 40px;
}

.list-number {
  background-color: #000;
  color: #fff;
  border-radius: 50%;
  width: 17px;
  height: 17px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}

.location-details {
  flex-grow: 1;
  display: flex;
  flex-wrap: wrap;
}

.detail {
  margin-right: 20px;
  font-size: 12px; /* Adjust the font size as needed */
}

.edit-text {
  color: #6f48ff;
  cursor: pointer;
  font-size: 12px;
}

.add-location-button {
  height: auto;
  width: 410px;
  cursor: pointer;
  transition: transform 0.3s;
}

.add-location-button:hover {
  transform: scale(1.01);
}

.plus-icon {
  font-size: 24px;
  margin-bottom: 5px;
}

.modal-body9 {
  max-height: 350px;
  overflow-y: auto;
}

.modal-body9::-webkit-scrollbar {
  width: 6px; /* Set the width of the scrollbar */
}

.modal-body9::-webkit-scrollbar-thumb {
  background-color: #c6c5cb; /* Set the color of the scrollbar thumb */
  border-radius: 3px; /* Optional: Add rounded corners to the thumb */
}

.modal-body0::-webkit-scrollbar-track {
  background-color: #f8f9fc; /* Set the color of the scrollbar track */
}

.file-upload-section {
  margin-top: 0px;
}

.upload-label {
  display: flex;
  text-align: center;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  border: 2px dashed #d3d5da;
  padding: 20px;
  border-radius: 5px;
}

.upload-icon {
  margin-bottom: 10px;
}

.small-text {
  font-size: 12px;
  text-align: center;
  color: #777;
}

.remove-file2 {
  top: 10px;
  right: 10px;
  cursor: pointer;
}

/* Hide the default file input */
.file-input {
  display: none;
}

.form-group {
  position: relative;
}

.dropdown-container {
  display: flex;
  align-items: center;
  position: relative;
}

.form-control {
  flex: 1;
  height: 40px;
  border-radius: 3px;
}

.dropdown-icon-container {
  margin-left: -25px;
  z-index: 1;
  cursor: pointer;
  position: relative;
}

.dropdown-icon {
  position: absolute;
  top: 50%;
  right: 5px;
  z-index: 1;
  transform: translateY(-50%);
  cursor: pointer;
}

.modal1 {
  background-color: #6f48ff;
  color: #fff;
  border: none;
  font-size: 14px;
  border-radius: 10px;
  cursor: pointer;
  margin-top: 2px;
  width: 30px;
  height: 5px;
}

.modal-text3 {
  font-size: 12px;
  font-weight: lighter;
}

.modal-header-text2 {
  margin-left: 2px;
  font-size: 17px;
  transition: color 0.3s;
  font-weight: bold;
  color: #000;
}

.custom-modal-width2 {
  width: 450px;
}

.center-content2 {
  text-align: center;
  margin-top: 120px;
}
</style>
